export const translations = {
    en: {
        common: {
            resetLearning: "↺ Reset Learning",
            resetConfirm: "Have you adjusted pitch links or trim tabs?\n\nThis will clear the history of previous steps so the algorithm can learn the new aerodynamic configuration.\n\nAre you sure?",
        },
        help: {
            pitchLinkReset: "After Blade Track Adjustments: If you adjust pitch links or trim tabs, the rotor behavior changes. You must click the 'Reset Learning' button to clear the old history. The next run will serve as a new calibration step."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 Rotor Balancing Assistant',
            mainRotor: 'Main Rotor',
            tailRotor: 'Tail Rotor',
            language: 'Language',
        },
        mainRotor: {
            backToHome: 'Back to Home',
            title: 'Main Rotor',
            step: 'Step',
            rotorIsBalanced: 'Rotor is Balanced!',
            vibrationBelowThreshold: 'Vibration amplitude ({amplitude} IPS) is below the 0.2 IPS threshold.',
            overweightWarningTitle: 'Small cavity full!',
            overweightWarningText: 'The recommendation exceeds 16g. Please contact support@guimbal.com.',
            vibrationMeasurement: 'Vibration Measurement',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>degrees</i>',
            phaseLabelDegreesShort: 'Degrees',
            weightDistribution: 'Weight Distribution',
            detailedWeightDistribution: 'Detailed Setup',
            currentlyInstalled: 'Current',
            current: 'Current',
            final: 'Final',
            fromPreviousStep: 'From previous step.',
            yellowBlade: 'Yellow Blade',
            greenBlade: 'Green Blade',
            redBlade: 'Red Blade',
            addToCurrentlyInstalled: 'Add to Currently Installed',
            add: 'Add',
            remove: 'Remove',
            grams: 'grams',
            recommended: 'Recommended',
            yourAction: 'Your Action',
            totalWeight: 'Total Weight',
            goToNextStep: 'Next Step',
            next: 'Next',
            goToPreviousStep: 'Previous Step',
            generateReport: 'Generate PDF Report',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balancing Plot',
            plotLegendRecommended: 'Current Vibration',
            plotLegendYourAction: 'Your Action',
        },
        tailRotor: {
            backToHome: 'Back to Home',
            title: 'Tail Rotor',
            step: 'Step',
            rotorIsBalanced: 'Rotor is Balanced!',
            vibrationBelowThreshold: 'Vibration amplitude ({amplitude} IPS) is below the 0.2 IPS threshold.',
            vibrationMeasurement: 'Vibration Measurement',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>degrees</i>',
            phaseLabelDegreesShort: 'Degrees',
            installedWeights: 'Installed Weights',
            detailedWeightDistribution: 'Detailed Weight Distribution',
            detailedSetup: 'Detailed Setup',
            screwLabel: 'Screw',
            smallWashers: 'Small Washers',
            largeWashers: 'Large Washers',
            current: 'Current',
            final: 'Final',
            add: 'Add',
            remove: 'Remove',
            washers: 'washers',
            enterWashers: 'Enter washers currently on rotor.',
            fromPreviousStep: '(From previous step)',
            small: 'Small',
            large: 'Large',
            recommendation: 'Recommendation',
            recommendationFinalSetup: 'Recommendation & Final Setup',
            recommendedFinalWashers: 'Recommended Final Washers',
            yourFinalWasherSetup: 'Your Final Washer Setup',
            editFinalSetup: 'Edit here to match the washers you actually installed, if different from the recommendation.',
            goToNextStep: 'Next Step',
            next: 'Next',
            goToPreviousStep: 'Previous Step',
            generateReport: 'Generate PDF Report',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balancing Plot',
        }
    },
    fr: {
        common: {
            resetLearning: "↺ Réinitialiser l'Apprentissage",
            resetConfirm: "Avez-vous ajusté les biellettes de pas ou les tabs ?\n\nCela effacera l'historique des étapes précédentes afin que l'algorithme puisse apprendre la nouvelle configuration aérodynamique.\n\nÊtes-vous sûr ?",
        },
        help: {
            pitchLinkReset: "Après réglage du tracking : Si vous ajustez les biellettes de pas ou les tabs, le comportement du rotor change. Vous devez cliquer sur le bouton 'Réinitialiser l'Apprentissage' pour effacer l'ancien historique. La prochaine mesure servira de nouvelle étape de calibration."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Équilibrage des rotors du Cabri G2',
            mainRotor: 'Rotor Principal',
            tailRotor: 'Rotor Arrière',
            language: 'Langue',
        },
        mainRotor: {
            backToHome: 'Retour à l\'accueil',
            title: 'Rotor Principal',
            step: 'Étape',
            rotorIsBalanced: 'Le rotor est équilibré !',
            vibrationBelowThreshold: 'L\'amplitude des vibrations ({amplitude} IPS) est inférieure au seuil de 0.2 IPS.',
            overweightWarningTitle: 'Petite cavité pleine !',
            overweightWarningText: 'La recommandation dépasse 16g. Veuillez contacter support@guimbal.com.',
            vibrationMeasurement: 'Mesure des Vibrations',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>degrés</i>',
            phaseLabelDegreesShort: 'Degrés',
            weightDistribution: 'Distribution des Poids',
            detailedWeightDistribution: 'Configuration Détaillée',
            currentlyInstalled: 'Actuel',
            current: 'Actuel',
            final: 'Final',
            fromPreviousStep: 'De l\'étape précédente.',
            yellowBlade: 'Pale Jaune',
            greenBlade: 'Pale Verte',
            redBlade: 'Pale Rouge',
            addToCurrentlyInstalled: 'Ajouter aux masselottes actuelles',
            add: 'Ajouter',
            remove: 'Retirer',
            grams: 'grammes',
            recommended: 'Recommandé',
            yourAction: 'Votre Action',
            totalWeight: 'Poids Total',
            goToNextStep: 'Suivant',
            next: 'Suivant',
            goToPreviousStep: 'Précédent',
            generateReport: 'Générer un Rapport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Graphique d\'équilibrage',
            plotLegendRecommended: 'Vibration Actuelle',
            plotLegendYourAction: 'Votre Action',
        },
        tailRotor: {
            backToHome: 'Retour à l\'accueil',
            title: 'Rotor Arrière',
            step: 'Étape',
            rotorIsBalanced: 'Le rotor est équilibré !',
            vibrationBelowThreshold: 'L\'amplitude des vibrations ({amplitude} IPS) est inférieure au seuil de 0.2 IPS.',
            vibrationMeasurement: 'Mesure des Vibrations',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>degrés</i>',
            phaseLabelDegreesShort: 'Degrés',
            installedWeights: 'Masselottes Installés',
            detailedWeightDistribution: 'Distribution Détaillée des Poids',
            detailedSetup: 'Configuration Détaillée',
            screwLabel: 'Vis',
            smallWashers: 'Petites Rondelles',
            largeWashers: 'Grandes Rondelles',
            current: 'Actuel',
            final: 'Final',
            add: 'Ajouter',
            remove: 'Retirer',
            washers: 'rondelles',
            enterWashers: 'Entrez les rondelles actuellement sur le rotor.',
            fromPreviousStep: '(De l\'étape précédente)',
            small: 'Petite',
            large: 'Grande',
            recommendation: 'Recommandation',
            recommendationFinalSetup: 'Recommandation & Configuration Finale',
            recommendedFinalWashers: 'Rondelles Recommandées (total)',
            yourFinalWasherSetup: 'Votre Configuration Rondelles (total)',
            editFinalSetup: 'Modifiez ici pour correspondre aux rondelles que vous avez réellement installées, si elles sont différentes de la recommandation.',
            goToNextStep: 'Suivant',
            next: 'Suivant',
            goToPreviousStep: 'Précédent',
            generateReport: 'Générer un Rapport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Graphique d\'équilibrage',
        }
    },
    es: {
        common: {
            resetLearning: "↺ Reiniciar Aprendizaje",
            resetConfirm: "¿Ha ajustado las bieletas de paso o los trim tabs?\n\nEsto borrará el historial de los pasos anteriores para que el algoritmo pueda aprender la nueva configuración aerodinámica.\n\n¿Está seguro?",
        },
        help: {
            pitchLinkReset: "Después de ajustar el tracking: Si ajusta las bieletas de paso o los trim tabs, el comportamiento del rotor cambia. Debe hacer clic en el botón 'Reiniciar Aprendizaje' para borrar el historial anterior. La siguiente ejecución servirá como un nuevo paso de calibración."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Asistente de Equilibrado de Rotores del Cabri G2',
            mainRotor: 'Rotor Principal',
            tailRotor: 'Rotor Trasero',
            language: 'Idioma',
        },
        mainRotor: {
            backToHome: 'Volver al Inicio',
            title: 'Rotor Principal',
            step: 'Paso',
            rotorIsBalanced: '¡Rotor Equilibrado!',
            vibrationBelowThreshold: 'La amplitud de la vibración ({amplitude} IPS) está por debajo del umbral de 0.2 IPS.',
            overweightWarningTitle: '¡Cavidad pequeña llena!',
            overweightWarningText: 'La recomendación excede 16g. Por favor, contacte a support@guimbal.com.',
            vibrationMeasurement: 'Medición de Vibración',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grados</i>',
            phaseLabelDegreesShort: 'Grados',
            weightDistribution: 'Distribución de Pesos',
            detailedWeightDistribution: 'Configuración Detallada',
            currentlyInstalled: 'Actual',
            current: 'Actual',
            final: 'Final',
            fromPreviousStep: 'Del paso anterior.',
            yellowBlade: 'Pala Amarilla',
            greenBlade: 'Pala Verde',
            redBlade: 'Pala Roja',
            recommendationAction: 'Recomendación y Acción',
            addToCurrentlyInstalled: 'Añadir a los Pesos Actuales',
            add: 'Añadir',
            remove: 'Quitar',
            grams: 'gramos',
            recommended: 'Recomendado',
            yourAction: 'Su Acción',
            totalWeight: 'Peso Total',
            goToNextStep: 'Siguiente',
            next: 'Siguiente',
            goToPreviousStep: 'Anterior',
            generateReport: 'Generar Informe PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Gráfico de Equilibrado',
            plotLegendRecommended: 'Vibración Actual',
            plotLegendYourAction: 'Su Acción',
        },
        tailRotor: {
            backToHome: 'Volver al Inicio',
            title: 'Rotor Trasero',
            step: 'Paso',
            rotorIsBalanced: '¡Rotor Equilibrado!',
            vibrationBelowThreshold: 'La amplitud de la vibración ({amplitude} IPS) está por debajo del umbral de 0.2 IPS.',
            vibrationMeasurement: 'Medición de Vibración',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grados</i>',
            phaseLabelDegreesShort: 'Grados',
            installedWeights: 'Pesos Instalados',
            detailedWeightDistribution: 'Distribución Detallada de Pesos',
            detailedSetup: 'Configuración Detallada',
            screwLabel: 'Tornillo',
            smallWashers: 'Arandelas Pequeñas',
            largeWashers: 'Arandelas Grandes',
            current: 'Actual',
            final: 'Final',
            add: 'Añadir',
            remove: 'Quitar',
            washers: 'arandelas',
            enterWashers: 'Introduzca las arandelas actualmente en el rotor.',
            fromPreviousStep: '(Del paso anterior)',
            small: 'Pequeña',
            large: 'Grande',
            recommendation: 'Recomendación',
            recommendationFinalSetup: 'Recomendación y Configuración Final',
            recommendedFinalWashers: 'Arandelas Recomendadas (total)',
            yourFinalWasherSetup: 'Su Configuración de Arandelas (total)',
            editFinalSetup: 'Edite aquí para que coincida con las arandelas que instaló realmente, si son diferentes de la recomendación.',
            goToNextStep: 'Siguiente',
            next: 'Siguiente',
            goToPreviousStep: 'Anterior',
            generateReport: 'Generar Informe PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Gráfico de Equilibrado',
        }
    },
    de: {
        common: {
            resetLearning: "↺ Lernen zurücksetzen",
            resetConfirm: "Haben Sie die Steuerstangen (Pitch Links) oder Trimmbleche verstellt?\n\nDies löscht den Verlauf der vorherigen Schritte, damit der Algorithmus die neue aerodynamische Konfiguration erlernen kann.\n\nSind Sie sicher?",
        },
        help: {
            pitchLinkReset: "Nach Spurlauf-Einstellungen: Wenn Sie Pitch Links oder Trimmbleche verstellen, ändert sich das Verhalten des Rotors. Sie müssen auf 'Lernen zurücksetzen' klicken, um den alten Verlauf zu löschen. Der nächste Lauf dient als neuer Kalibrierungsschritt."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Assistent für das Auswuchten von Cabri G2 Rotoren',
            mainRotor: 'Hauptrotor',
            tailRotor: 'Heckrotor',
            language: 'Sprache',
        },
        mainRotor: {
            backToHome: 'Zurück zur Startseite',
            title: 'Hauptrotor',
            step: 'Schritt',
            rotorIsBalanced: 'Rotor ist ausgewuchtet!',
            vibrationBelowThreshold: 'Die Schwingungsamplitude ({amplitude} IPS) liegt unter dem Schwellenwert von 0.2 IPS.',
            overweightWarningTitle: 'Kleiner Hohlraum voll!',
            overweightWarningText: 'Die Empfehlung überschreitet 16g. Bitte kontaktieren Sie support@guimbal.com.',
            vibrationMeasurement: 'Schwingungsmessung',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>Grad</i>',
            phaseLabelDegreesShort: 'Grad',
            weightDistribution: 'Gewichtsverteilung',
            detailedWeightDistribution: 'Detaillierte Einrichtung',
            currentlyInstalled: 'Aktuell',
            current: 'Aktuell',
            final: 'Final',
            fromPreviousStep: 'Aus dem vorherigen Schritt.',
            yellowBlade: 'Gelbes Blatt',
            greenBlade: 'Grünes Blatt',
            redBlade: 'Rotes Blatt',
            recommendationAction: 'Empfehlung & Aktion',
            addToCurrentlyInstalled: 'Zu den aktuell installierten hinzufügen',
            add: 'Hinzufügen',
            remove: 'Entfernen',
            grams: 'Gramm',
            recommended: 'Empfohlen',
            yourAction: 'Ihre Aktion',
            totalWeight: 'Gesamtgewicht',
            goToNextStep: 'Nächster Schritt',
            next: 'Weiter',
            goToPreviousStep: 'Vorheriger Schritt',
            generateReport: 'PDF-Bericht erstellen',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Auswuchtdiagramm',
            plotLegendRecommended: 'Aktuelle Vibration',
            plotLegendYourAction: 'Ihre Aktion',
        },
        tailRotor: {
            backToHome: 'Zurück zur Startseite',
            title: 'Heckrotor',
            step: 'Schritt',
            rotorIsBalanced: 'Rotor ist ausgewuchtet!',
            vibrationBelowThreshold: 'Die Schwingungsamplitude ({amplitude} IPS) liegt unter dem Schwellenwert von 0.2 IPS.',
            vibrationMeasurement: 'Schwingungsmessung',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Phase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>Grad</i>',
            phaseLabelDegreesShort: 'Grad',
            installedWeights: 'Installierte Gewichte',
            detailedWeightDistribution: 'Detaillierte Gewichtsverteilung',
            detailedSetup: 'Detaillierte Einrichtung',
            screwLabel: 'Schraube',
            smallWashers: 'Kleine Unterlegscheiben',
            largeWashers: 'Große Unterlegscheiben',
            current: 'Aktuell',
            final: 'Final',
            add: 'Hinzufügen',
            remove: 'Entfernen',
            washers: 'Scheiben',
            enterWashers: 'Geben Sie die aktuell am Rotor befindlichen Unterlegscheiben ein.',
            fromPreviousStep: '(Aus dem vorherigen Schritt)',
            small: 'Klein',
            large: 'Groß',
            recommendation: 'Empfehlung',
            recommendationFinalSetup: 'Empfehlung & Endgültige Konfiguration',
            recommendedFinalWashers: 'Empfohlene Unterlegscheiben (gesamt)',
            yourFinalWasherSetup: 'Ihre endgültige Unterlegscheiben-Konfiguration (gesamt)',
            editFinalSetup: 'Bearbeiten Sie dies hier, um es an die tatsächlich installierten Unterlegscheiben anzupassen, falls diese von der Empfehlung abweichen.',
            goToNextStep: 'Nächster Schritt',
            next: 'Weiter',
            goToPreviousStep: 'Vorheriger Schritt',
            generateReport: 'PDF-Bericht erstellen',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Auswuchtdiagramm',
        }
    },
    it: {
        common: {
            resetLearning: "↺ Resetta Apprendimento",
            resetConfirm: "Hai regolato le biellette di passo o i trim tabs?\n\nQuesto cancellerà la cronologia dei passaggi precedenti affinché l'algoritmo possa apprendere la nuova configurazione aerodinamica.\n\nSei sicuro?",
        },
        help: {
            pitchLinkReset: "Dopo regolazioni del tracking: Se regoli le biellette di passo o i trim tabs, il comportamento del rotore cambia. Devi cliccare sul pulsante 'Resetta Apprendimento' per cancellare la vecchia cronologia. La prossima misurazione servirà come nuovo passaggio di calibrazione."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Assistente al bilanciamento dei rotori del Cabri G2',
            mainRotor: 'Rotore Principale',
            tailRotor: 'Rotore Posteriore',
            language: 'Lingua',
        },
        mainRotor: {
            backToHome: 'Torna alla Home',
            title: 'Rotore Principale',
            step: 'Passo',
            rotorIsBalanced: 'Rotore Bilanciato!',
            vibrationBelowThreshold: 'L\'ampiezza delle vibrazioni ({amplitude} IPS) è inferiore alla soglia di 0.2 IPS.',
            overweightWarningTitle: 'Cavità piccola piena!',
            overweightWarningText: 'La raccomandazione supera i 16g. Si prega di contattare support@guimbal.com.',
            vibrationMeasurement: 'Misurazione Vibrazioni',
            amplitudeLabel: 'Ampiezza <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>gradi</i>',
            phaseLabelDegreesShort: 'Gradi',
            weightDistribution: 'Distribuzione Pesi',
            detailedWeightDistribution: 'Configurazione Dettagliata',
            currentlyInstalled: 'Attuale',
            current: 'Attuale',
            final: 'Finale',
            fromPreviousStep: 'Dal passo precedente.',
            yellowBlade: 'Pala Gialla',
            greenBlade: 'Pala Verde',
            redBlade: 'Pala Rossa',
            recommendationAction: 'Raccomandazione e Azione',
            addToCurrentlyInstalled: 'Aggiungi ai Pesi Attuali',
            add: 'Aggiungi',
            remove: 'Rimuovi',
            grams: 'grammi',
            recommended: 'Raccomandato',
            yourAction: 'La Tua Azione',
            totalWeight: 'Peso Totale',
            goToNextStep: 'Passo Successivo',
            next: 'Avanti',
            goToPreviousStep: 'Passo Precedente',
            generateReport: 'Genera Report PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Grafico di Bilanciamento',
            plotLegendRecommended: 'Vibrazione Attuale',
            plotLegendYourAction: 'La Tua Azione',
        },
        tailRotor: {
            backToHome: 'Torna alla Home',
            title: 'Rotore Posteriore',
            step: 'Passo',
            rotorIsBalanced: 'Rotore Bilanciato!',
            vibrationBelowThreshold: 'L\'ampiezza delle vibrazioni ({amplitude} IPS) è inferiore alla soglia di 0.2 IPS.',
            vibrationMeasurement: 'Misurazione Vibrazioni',
            amplitudeLabel: 'Ampiezza <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>gradi</i>',
            phaseLabelDegreesShort: 'Gradi',
            installedWeights: 'Pesi Installati',
            detailedWeightDistribution: 'Distribuzione Pesi Dettagliata',
            detailedSetup: 'Configurazione Dettagliata',
            screwLabel: 'Vite',
            smallWashers: 'Rondelle Piccole',
            largeWashers: 'Rondelle Grandi',
            current: 'Attuale',
            final: 'Finale',
            add: 'Aggiungi',
            remove: 'Rimuovi',
            washers: 'rondelle',
            enterWashers: 'Inserire le rondelle attualmente sul rotore.',
            fromPreviousStep: '(Dal passo precedente)',
            small: 'Piccola',
            large: 'Grande',
            recommendation: 'Raccomandazione',
            recommendationFinalSetup: 'Raccomandazione e Configurazione Finale',
            recommendedFinalWashers: 'Rondelle Raccomandate (totale)',
            yourFinalWasherSetup: 'La Tua Configurazione Rondelle (totale)',
            editFinalSetup: 'Modifica qui per corrispondere alle rondelle effettivamente installate, se diverse dalla raccomandazione.',
            goToNextStep: 'Passo Successivo',
            next: 'Avanti',
            goToPreviousStep: 'Passo Precedente',
            generateReport: 'Genera Report PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Grafico di Bilanciamento',
        }
    },
    zh: {
        common: {
            resetLearning: "↺ 重置学习",
            resetConfirm: "您是否调整了变距拉杆或调整片？\n\n这将清除先前步骤的历史记录，以便算法可以学习新的空气动力学配置。\n\n您确定吗？",
        },
        help: {
            pitchLinkReset: "调整桨叶轨迹后：如果您调整了变距拉杆或调整片，旋翼行为会发生变化。您必须点击“重置学习”按钮以清除旧的历史记录。下一次运行将作为新的校准步骤。"
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 旋翼平衡助手',
            mainRotor: '主旋翼',
            tailRotor: '后旋翼',
            language: '语言',
        },
        mainRotor: {
            backToHome: '返回首页',
            title: '主旋翼',
            step: '步骤',
            rotorIsBalanced: '旋翼已平衡！',
            vibrationBelowThreshold: '振动幅度 ({amplitude} IPS) 低于 0.2 IPS 的阈值。',
            overweightWarningTitle: '小腔已满！',
            overweightWarningText: '建议重量超过16克。请联系 support@guimbal.com。',
            vibrationMeasurement: '振动测量',
            amplitudeLabel: '振幅 <i>IPS</i>',
            phaseLabelHHMM: '相位 <i>hh:mm</i>',
            phaseLabelDegrees: '<i>度</i>',
            phaseLabelDegreesShort: '度',
            weightDistribution: '配重分布',
            detailedWeightDistribution: '详细设置',
            currentlyInstalled: '当前',
            current: '当前',
            final: '最终',
            fromPreviousStep: '来自上一步。',
            yellowBlade: '黄色桨叶',
            greenBlade: '绿色桨叶',
            redBlade: '红色桨叶',
            recommendationAction: '建议与操作',
            addToCurrentlyInstalled: '添加到当前安装的配重',
            add: '增加',
            remove: '减少',
            grams: '克',
            recommended: '建议值',
            yourAction: '您的操作',
            totalWeight: '总重量',
            goToNextStep: '下一步',
            next: '下一步',
            goToPreviousStep: '上一步',
            generateReport: '生成PDF报告',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: '平衡图',
            plotLegendRecommended: '当前振动',
            plotLegendYourAction: '您的操作',
        },
        tailRotor: {
            backToHome: '返回首页',
            title: '后旋翼',
            step: '步骤',
            rotorIsBalanced: '旋翼已平衡！',
            vibrationBelowThreshold: '振动幅度 ({amplitude} IPS) 低于 0.2 IPS 的阈值。',
            vibrationMeasurement: '振动测量',
            amplitudeLabel: '振幅 <i>IPS</i>',
            phaseLabelHHMM: '相位 <i>hh:mm</i>',
            phaseLabelDegrees: '<i>度</i>',
            phaseLabelDegreesShort: '度',
            installedWeights: '已安装的配重',
            detailedWeightDistribution: '详细配重分布',
            detailedSetup: '详细设置',
            screwLabel: '螺丝',
            smallWashers: '小垫圈',
            largeWashers: '大垫圈',
            current: '当前',
            final: '最终',
            add: '增加',
            remove: '减少',
            washers: '垫圈',
            enterWashers: '输入当前在旋翼上的垫圈。',
            fromPreviousStep: '（来自上一步）',
            small: '小',
            large: '大',
            recommendation: '建议',
            recommendationFinalSetup: '建议与最终设置',
            recommendedFinalWashers: '建议的最终垫圈 (总计)',
            yourFinalWasherSetup: '您的最终垫圈设置 (总计)',
            editFinalSetup: '如果与建议不同，请在此处编辑以匹配您实际安装的垫圈。',
            goToNextStep: '下一步',
            next: '下一步',
            goToPreviousStep: '上一步',
            generateReport: '生成PDF报告',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: '平衡图',
        }
    },
    pt: {
        common: {
            resetLearning: "↺ Redefinir Aprendizagem",
            resetConfirm: "Você ajustou os pitch links ou os trim tabs?\n\nIsso limpará o histórico das etapas anteriores para que o algoritmo possa aprender a nova configuração aerodinâmica.\n\nTem certeza?",
        },
        help: {
            pitchLinkReset: "Após ajustes de tracking: Se você ajustar pitch links ou trim tabs, o comportamento do rotor muda. Você deve clicar no botão 'Redefinir Aprendizagem' para limpar o histórico antigo. A próxima execução servirá como uma nova etapa de calibração."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Assistente de Balanceamento de Rotor do Cabri G2',
            mainRotor: 'Rotor Principal',
            tailRotor: 'Rotor Traseiro',
            language: 'Idioma',
        },
        mainRotor: {
            backToHome: 'Voltar ao Início',
            title: 'Rotor Principal',
            step: 'Passo',
            rotorIsBalanced: 'Rotor Balanceado!',
            vibrationBelowThreshold: 'A amplitude da vibração ({amplitude} IPS) está abaixo do limiar de 0.2 IPS.',
            overweightWarningTitle: 'Cavidade pequena cheia!',
            overweightWarningText: 'A recomendação excede 16g. Por favor, entre em contato com support@guimbal.com.',
            vibrationMeasurement: 'Medição de Vibração',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>graus</i>',
            phaseLabelDegreesShort: 'Graus',
            weightDistribution: 'Distribuição de Peso',
            detailedWeightDistribution: 'Configuração Detalhada',
            currentlyInstalled: 'Atual',
            current: 'Atual',
            final: 'Final',
            fromPreviousStep: 'Do passo anterior.',
            yellowBlade: 'Pá Amarela',
            greenBlade: 'Pá Verde',
            redBlade: 'Pá Vermelha',
            recommendationAction: 'Recomendação e Ação',
            addToCurrentlyInstalled: 'Adicionar aos Pesos Atuais',
            add: 'Adicionar',
            remove: 'Remover',
            grams: 'gramas',
            recommended: 'Recomendado',
            yourAction: 'Sua Ação',
            totalWeight: 'Peso Total',
            goToNextStep: 'Próximo Passo',
            next: 'Próximo',
            goToPreviousStep: 'Passo Anterior',
            generateReport: 'Gerar Relatório PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Gráfico de Balanceamento',
            plotLegendRecommended: 'Vibração Atual',
            plotLegendYourAction: 'Sua Ação',
        },
        tailRotor: {
            backToHome: 'Voltar ao Início',
            title: 'Rotor Traseiro',
            step: 'Passo',
            rotorIsBalanced: 'Rotor Balanceado!',
            vibrationBelowThreshold: 'A amplitude da vibração ({amplitude} IPS) está abaixo do limiar de 0.2 IPS.',
            vibrationMeasurement: 'Medição de Vibração',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>hh:mm</i>',
            phaseLabelDegrees: '<i>graus</i>',
            phaseLabelDegreesShort: 'Graus',
            installedWeights: 'Pesos Instalados',
            detailedWeightDistribution: 'Distribuição Detalhada de Peso',
            detailedSetup: 'Configuração Detalhada',
            screwLabel: 'Parafuso',
            smallWashers: 'Arruelas Pequenas',
            largeWashers: 'Arruelas Grandes',
            current: 'Atual',
            final: 'Final',
            add: 'Adicionar',
            remove: 'Remover',
            washers: 'arruelas',
            enterWashers: 'Insira as arruelas atualmente no rotor.',
            fromPreviousStep: '(Do passo anterior)',
            small: 'Pequena',
            large: 'Grande',
            recommendation: 'Recomendação',
            recommendationFinalSetup: 'Recomendação e Configuração Final',
            recommendedFinalWashers: 'Arruelas Finais Recomendadas (total)',
            yourFinalWasherSetup: 'Sua Configuração Final de Arruelas (total)',
            editFinalSetup: 'Edite aqui para corresponder às arruelas que você realmente instalou, se forem diferentes da recomendação.',
            goToNextStep: 'Próximo Passo',
            next: 'Próximo',
            goToPreviousStep: 'Passo Anterior',
            generateReport: 'Gerar Relatório PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Gráfico de Balanceamento',
        }
    },
    hy: {
        common: {
            resetLearning: "↺ Վերականգնել ուսուցումը",
            resetConfirm: "Դուք կարգավորե՞լ եք pitch link-երը կամ trim tab-երը:\n\nՍա կջնջի նախորդ քայլերի պատմությունը, որպեսզի ալգորիթմը կարողանա սովորել նոր աերոդինամիկ կոնֆիգուրացիան:\n\nՎստա՞հ եք:",
        },
        help: {
            pitchLinkReset: "Blade Track կարգավորումներից հետո. Եթե դուք կարգավորում եք pitch link-երը կամ trim tab-երը, ռոտորի վարքագիծը փոխվում է: Դուք պետք է սեղմեք 'Վերականգնել ուսուցումը' կոճակը՝ հին պատմությունը ջնջելու համար: Հաջորդ գործարկումը կծառայի որպես նոր չափաբերման քայլ:"
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 ռոտորի հավասարակշռման օգնական',
            mainRotor: 'Գլխավոր ռոտոր',
            tailRotor: 'Ետևի ռոտոր',
            language: 'Լեզու',
        },
        mainRotor: {
            backToHome: 'Վերադառնալ գլխավոր էջ',
            title: 'Գլխավոր ռոտոր',
            step: 'Քայլ',
            rotorIsBalanced: 'Ռոտորը հավասարակշռված է։',
            vibrationBelowThreshold: 'Թրթռման ամպլիտուդը ({amplitude} IPS) ցածր է 0.2 IPS շեմից։',
            overweightWarningTitle: 'Փոքր խոռոչը լի է։',
            overweightWarningText: 'Առաջարկությունը գերազանցում է 16գ։ Խնդրում ենք կապվել support@guimbal.com։',
            vibrationMeasurement: 'Թրթռման չափում',
            amplitudeLabel: 'Ամպլիտուդ <i>IPS</i>',
            phaseLabelHHMM: 'Ֆազ <i>ժժ:րր</i>',
            phaseLabelDegrees: '<i>աստիճան</i>',
            phaseLabelDegreesShort: 'Աստիճան',
            weightDistribution: 'Քաշի բաշխում',
            detailedWeightDistribution: 'Մանրամասն կարգավորում',
            currentlyInstalled: 'Ընթացիկ',
            current: 'Ընթացիկ',
            final: 'Վերջնական',
            fromPreviousStep: 'Նախորդ քայլից։',
            yellowBlade: 'Դեղին թիակ',
            greenBlade: 'Կանաչ թիակ',
            redBlade: 'Կարմիր թիակ',
            recommendationAction: 'Առաջարկ և գործողություն',
            addToCurrentlyInstalled: 'Ավելացնել ընթացիկ կշիռներին',
            add: 'Ավելացնել',
            remove: 'Հեռացնել',
            grams: 'գրամ',
            recommended: 'Առաջարկվող',
            yourAction: 'Ձեր գործողությունը',
            totalWeight: 'Ընդհանուր քաշ',
            goToNextStep: 'Հաջորդ քայլ',
            next: 'Հաջորդ',
            goToPreviousStep: 'Նախորդ քայլ',
            generateReport: 'Ստեղծել PDF հաշվետվություն',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Հավասարակշռման գծապատկեր',
            plotLegendRecommended: 'Ընթացիկ թրթռում',
            plotLegendYourAction: 'Ձեր գործողությունը',
        },
        tailRotor: {
            backToHome: 'Վերադառնալ գլխավոր էջ',
            title: 'Ետևի ռոտոր',
            step: 'Քայլ',
            rotorIsBalanced: 'Ռոտորը հավասարակշռված է։',
            vibrationBelowThreshold: 'Թրթռման ամպլիտուդը ({amplitude} IPS) ցածր է 0.2 IPS շեմից։',
            vibrationMeasurement: 'Թրթռման չափում',
            amplitudeLabel: 'Ամպլիտուդ <i>IPS</i>',
            phaseLabelHHMM: 'Ֆազ <i>ժժ:րր</i>',
            phaseLabelDegrees: '<i>աստիճան</i>',
            phaseLabelDegreesShort: 'Աստիճան',
            installedWeights: 'Տեղադրված կշիռներ',
            detailedWeightDistribution: 'Քաշի մանրամասն բաշխում',
            detailedSetup: 'Մանրամասն կարգավորում',
            screwLabel: 'Պտուտակ',
            smallWashers: 'Փոքր լվացողներ',
            largeWashers: 'Մեծ լվացողներ',
            current: 'Ընթացիկ',
            final: 'Վերջնական',
            add: 'Ավելացնել',
            remove: 'Հեռացնել',
            washers: 'լվացողներ',
            enterWashers: 'Մուտքագրեք ներկայումս ռոտորի վրա գտնվող լվացող մեքենաները։',
            fromPreviousStep: '(Նախորդ քայլից)',
            small: 'Փոքր',
            large: 'Մեծ',
            recommendation: 'Առաջարկ',
            recommendationFinalSetup: 'Առաջարկ և վերջնական կարգավորում',
            recommendedFinalWashers: 'Առաջարկվող վերջնական լվացող մեքենաներ (ընդհանուր)',
            yourFinalWasherSetup: 'Ձեր վերջնական լվացող մեքենաների կարգավորումը (ընդհանուր)',
            editFinalSetup: 'Խմբագրեք այստեղ՝ համապատասխանեցնելու համար իրականում տեղադրված լվացող մեքենաներին, եթե դրանք տարբերվում են առաջարկից։',
            goToNextStep: 'Հաջորդ քայլ',
            next: 'Հաջորդ',
            goToPreviousStep: 'Նախորդ քայլ',
            generateReport: 'Ստեղծել PDF հաշվետվություն',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Հավասարակշռման գծապատկեր',
        }
    },
    ms: {
        common: {
            resetLearning: "↺ Tetapkan Semula Pembelajaran",
            resetConfirm: "Adakah anda telah melaraskan pautan padang (pitch links) atau tab trim?\n\nIni akan mengosongkan sejarah langkah sebelumnya supaya algoritma boleh mempelajari konfigurasi aerodinamik baharu.\n\nAdakah anda pasti?",
        },
        help: {
            pitchLinkReset: "Selepas Pelarasan Jejak Bilah: Jika anda melaraskan pautan padang atau tab trim, kelakuan rotor berubah. Anda mesti mengklik butang 'Tetapkan Semula Pembelajaran' untuk mengosongkan sejarah lama. Larian seterusnya akan berfungsi sebagai langkah penentukuran baharu."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Pembantu Imbangan Rotor Cabri G2',
            mainRotor: 'Rotor Utama',
            tailRotor: 'Rotor Belakang',
            language: 'Bahasa',
        },
        mainRotor: {
            backToHome: 'Kembali ke Laman Utama',
            title: 'Rotor Utama',
            step: 'Langkah',
            rotorIsBalanced: 'Rotor Seimbang!',
            vibrationBelowThreshold: 'Amplitud getaran ({amplitude} IPS) di bawah ambang 0.2 IPS.',
            overweightWarningTitle: 'Rongga kecil penuh!',
            overweightWarningText: 'Cadangan melebihi 16g. Sila hubungi support@guimbal.com.',
            vibrationMeasurement: 'Ukuran Getaran',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fasa <i>hh:mm</i>',
            phaseLabelDegrees: '<i>darjah</i>',
            phaseLabelDegreesShort: 'Darjah',
            weightDistribution: 'Agihan Berat',
            detailedWeightDistribution: 'Persediaan Terperinci',
            currentlyInstalled: 'Semasa',
            current: 'Semasa',
            final: 'Akhir',
            fromPreviousStep: 'Dari langkah sebelumnya.',
            yellowBlade: 'Bilah Kuning',
            greenBlade: 'Bilah Hijau',
            redBlade: 'Bilah Merah',
            recommendationAction: 'Cadangan & Tindakan',
            addToCurrentlyInstalled: 'Tambah kepada Berat Terpasang',
            add: 'Tambah',
            remove: 'Buang',
            grams: 'gram',
            recommended: 'Dicadangkan',
            yourAction: 'Tindakan Anda',
            totalWeight: 'Jumlah Berat',
            goToNextStep: 'Langkah Seterusnya',
            next: 'Seterusnya',
            goToPreviousStep: 'Langkah Sebelumnya',
            generateReport: 'Jana Laporan PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Plot Imbangan',
            plotLegendRecommended: 'Getaran Semasa',
            plotLegendYourAction: 'Tindakan Anda',
        },
        tailRotor: {
            backToHome: 'Kembali ke Laman Utama',
            title: 'Rotor Belakang',
            step: 'Langkah',
            rotorIsBalanced: 'Rotor Seimbang!',
            vibrationBelowThreshold: 'Amplitud getaran ({amplitude} IPS) di bawah ambang 0.2 IPS.',
            vibrationMeasurement: 'Ukuran Getaran',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fasa <i>hh:mm</i>',
            phaseLabelDegrees: '<i>darjah</i>',
            phaseLabelDegreesShort: 'Darjah',
            installedWeights: 'Berat Terpasang',
            detailedWeightDistribution: 'Agihan Berat Terperinci',
            detailedSetup: 'Persediaan Terperinci',
            screwLabel: 'Skru',
            smallWashers: 'Sesendal Kecil',
            largeWashers: 'Sesendal Besar',
            current: 'Semasa',
            final: 'Akhir',
            add: 'Tambah',
            remove: 'Buang',
            washers: 'sesendal',
            enterWashers: 'Masukkan sesendal yang sedang ada pada rotor.',
            fromPreviousStep: '(Dari langkah sebelumnya)',
            small: 'Kecil',
            large: 'Besar',
            recommendation: 'Cadangan',
            recommendationFinalSetup: 'Cadangan & Persediaan Akhir',
            recommendedFinalWashers: 'Sesendal Akhir Dicadangkan (jumlah)',
            yourFinalWasherSetup: 'Persediaan Sesendal Akhir Anda (jumlah)',
            editFinalSetup: 'Edit di sini untuk memadankan sesendal yang anda pasang sebenarnya, jika berbeza daripada cadangan.',
            goToNextStep: 'Langkah Seterusnya',
            next: 'Seterusnya',
            goToPreviousStep: 'Langkah Sebelumnya',
            generateReport: 'Jana Laporan PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Plot Imbangan',
        }
    },
    pl: {
        common: {
            resetLearning: "↺ Zresetuj Uczenie",
            resetConfirm: "Czy regulowałeś cięgna (pitch links) lub klapki wyważające (trim tabs)?\n\nSpowoduje to wyczyszczenie historii poprzednich kroków, aby algorytm mógł nauczyć się nowej konfiguracji aerodynamicznej.\n\nJesteś pewien?",
        },
        help: {
            pitchLinkReset: "Po regulacji torowania łopat: Jeśli wyregulujesz cięgna (pitch links) lub klapki wyważające (trim tabs), zachowanie wirnika ulegnie zmianie. Musisz kliknąć przycisk „Zresetuj Uczenie”, aby wyczyścić starą historię. Następny przebieg posłuży jako nowy krok kalibracyjny."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Asystent wyważania wirników Cabri G2',
            mainRotor: 'Wirnik główny',
            tailRotor: 'Wirnik tylny',
            language: 'Język',
        },
        mainRotor: {
            backToHome: 'Powrót do strony głównej',
            title: 'Wirnik główny',
            step: 'Krok',
            rotorIsBalanced: 'Wirnik jest wyważony!',
            vibrationBelowThreshold: 'Amplituda wibracji ({amplitude} IPS) jest poniżej progu 0.2 IPS.',
            overweightWarningTitle: 'Mała wnęka pełna!',
            overweightWarningText: 'Zalecenie przekracza 16g. Prosimy o kontakt z support@guimbal.com.',
            vibrationMeasurement: 'Pomiar wibracji',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Faza <i>hh:mm</i>',
            phaseLabelDegrees: '<i>stopnie</i>',
            phaseLabelDegreesShort: 'Stopnie',
            weightDistribution: 'Rozkład mas',
            detailedWeightDistribution: 'Szczegółowa konfiguracja',
            currentlyInstalled: 'Obecnie',
            current: 'Obecnie',
            final: 'Końcowa',
            fromPreviousStep: 'Z poprzedniego kroku.',
            yellowBlade: 'Żółta łopata',
            greenBlade: 'Zielona łopata',
            redBlade: 'Czerwona łopata',
            recommendationAction: 'Zalecenie i działanie',
            addToCurrentlyInstalled: 'Dodaj do obecnie zainstalowanych',
            add: 'Dodaj',
            remove: 'Usuń',
            grams: 'gramy',
            recommended: 'Zalecane',
            yourAction: 'Twoje działanie',
            totalWeight: 'Masa całkowita',
            goToNextStep: 'Następny krok',
            next: 'Dalej',
            goToPreviousStep: 'Poprzedni krok',
            generateReport: 'Generuj raport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Wykres wyważania',
            plotLegendRecommended: 'Obecne wibracje',
            plotLegendYourAction: 'Twoje działanie',
        },
        tailRotor: {
            backToHome: 'Powrót do strony głównej',
            title: 'Wirnik tylny',
            step: 'Krok',
            rotorIsBalanced: 'Wirnik jest wyważony!',
            vibrationBelowThreshold: 'Amplituda wibracji ({amplitude} IPS) jest poniżej progu 0.2 IPS.',
            vibrationMeasurement: 'Pomiar wibracji',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Faza <i>hh:mm</i>',
            phaseLabelDegrees: '<i>stopnie</i>',
            phaseLabelDegreesShort: 'Stopnie',
            installedWeights: 'Zainstalowane odważniki',
            detailedWeightDistribution: 'Szczegółowy rozkład mas',
            detailedSetup: 'Szczegółowa konfiguracja',
            screwLabel: 'Śruba',
            smallWashers: 'Małe Podkładki',
            largeWashers: 'Duże Podkładki',
            current: 'Obecnie',
            final: 'Końcowa',
            add: 'Dodaj',
            remove: 'Usuń',
            washers: 'podkładki',
            enterWashers: 'Wprowadź podkładki aktualnie na wirniku.',
            fromPreviousStep: '(Z poprzedniego kroku)',
            small: 'Mała',
            large: 'Duża',
            recommendation: 'Zalecenie',
            recommendationFinalSetup: 'Zalecenie i końcowa konfiguracja',
            recommendedFinalWashers: 'Zalecane podkładki końcowe (suma)',
            yourFinalWasherSetup: 'Twoja końcowa konfiguracja podkładek (suma)',
            editFinalSetup: 'Edytuj tutaj, aby dopasować do podkładek, które faktycznie zainstalowałeś, jeśli różnią się od zalecenia.',
            goToNextStep: 'Następny krok',
            next: 'Dalej',
            goToPreviousStep: 'Poprzedni krok',
            generateReport: 'Generuj raport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Wykres wyważania',
        }
    },
    cs: {
        common: {
            resetLearning: "↺ Resetovat učení",
            resetConfirm: "Upravili jste táhla (pitch links) nebo vyvažovací plošky (trim tabs)?\n\nTím se vymaže historie předchozích kroků, aby se algoritmus mohl naučit novou aerodynamickou konfiguraci.\n\nJste si jisti?",
        },
        help: {
            pitchLinkReset: "Po úpravě stopy listů: Pokud upravíte táhla (pitch links) nebo vyvažovací plošky, chování rotoru se změní. Musíte kliknout na tlačítko 'Resetovat učení', abyste vymazali starou historii. Další běh bude sloužit jako nový kalibrační krok."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Asistent pro vyvažování rotorů Cabri G2',
            mainRotor: 'Hlavní rotor',
            tailRotor: 'Zadní rotor',
            language: 'Jazyk',
        },
        mainRotor: {
            backToHome: 'Zpět na domovskou stránku',
            title: 'Hlavní rotor',
            step: 'Krok',
            rotorIsBalanced: 'Rotor je vyvážený!',
            vibrationBelowThreshold: 'Amplituda vibrací ({amplitude} IPS) je pod prahem 0.2 IPS.',
            overweightWarningTitle: 'Malá dutina plná!',
            overweightWarningText: 'Doporučení přesahuje 16g. Kontaktujte prosím support@guimbal.com.',
            vibrationMeasurement: 'Měření vibrací',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Fáze <i>hh:mm</i>',
            phaseLabelDegrees: '<i>stupně</i>',
            phaseLabelDegreesShort: 'Stupně',
            weightDistribution: 'Rozložení hmotnosti',
            detailedWeightDistribution: 'Podrobné nastavení',
            currentlyInstalled: 'Aktuální',
            current: 'Aktuální',
            final: 'Konečné',
            fromPreviousStep: 'Z předchozího kroku.',
            yellowBlade: 'Žlutý list',
            greenBlade: 'Zelený list',
            redBlade: 'Červený list',
            recommendationAction: 'Doporučení a akce',
            addToCurrentlyInstalled: 'Přidat k aktuálně instalovaným',
            add: 'Přidat',
            remove: 'Odebrat',
            grams: 'gramy',
            recommended: 'Doporučeno',
            yourAction: 'Vaše akce',
            totalWeight: 'Celková hmotnost',
            goToNextStep: 'Další krok',
            next: 'Další',
            goToPreviousStep: 'Předchozí krok',
            generateReport: 'Generovat zprávu PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Graf vyvažování',
            plotLegendRecommended: 'Aktuální vibrace',
            plotLegendYourAction: 'Vaše akce',
        },
        tailRotor: {
            backToHome: 'Zpět na domovskou stránku',
            title: 'Zadní rotor',
            step: 'Krok',
            rotorIsBalanced: 'Rotor je vyvážený!',
            vibrationBelowThreshold: 'Amplituda vibrací ({amplitude} IPS) je pod prahem 0.2 IPS.',
            vibrationMeasurement: 'Měření vibrací',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Fáze <i>hh:mm</i>',
            phaseLabelDegrees: '<i>stupně</i>',
            phaseLabelDegreesShort: 'Stupně',
            installedWeights: 'Instalované závaží',
            detailedWeightDistribution: 'Podrobné rozložení hmotnosti',
            detailedSetup: 'Podrobné nastavení',
            screwLabel: 'Šroub',
            smallWashers: 'Malé Podložky',
            largeWashers: 'Velké Podložky',
            current: 'Aktuální',
            final: 'Konečné',
            add: 'Přidat',
            remove: 'Odebrat',
            washers: 'podložky',
            enterWashers: 'Zadejte podložky aktuálně na rotoru.',
            fromPreviousStep: '(Z předchozího kroku)',
            small: 'Malá',
            large: 'Velká',
            recommendation: 'Doporučení',
            recommendationFinalSetup: 'Doporučení a konečné nastavení',
            recommendedFinalWashers: 'Doporučené konečné podložky (celkem)',
            yourFinalWasherSetup: 'Vaše konečné nastavení podložek (celkem)',
            editFinalSetup: 'Upravte zde, aby odpovídalo podložkám, které jste skutečně nainstalovali, pokud se liší od doporučení.',
            goToNextStep: 'Další krok',
            next: 'Další',
            goToPreviousStep: 'Předchozí krok',
            generateReport: 'Generovat zprávu PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Graf vyvažování',
        }
    },
    ro: {
        common: {
            resetLearning: "↺ Resetează Învățarea",
            resetConfirm: "Ați reglat bieletele de pas (pitch links) sau trim tabs?\n\nAceasta va șterge istoricul pașilor anteriori, astfel încât algoritmul să poată învăța noua configurație aerodinamică.\n\nSunteți sigur?",
        },
        help: {
            pitchLinkReset: "După ajustarea tracking-ului: Dacă ajustați bieletele de pas sau trim tabs, comportamentul rotorului se schimbă. Trebuie să faceți clic pe butonul 'Resetează Învățarea' pentru a șterge istoricul vechi. Următoarea rulare va servi ca un nou pas de calibrare."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Asistent pentru echilibrarea rotoarelor Cabri G2',
            mainRotor: 'Rotor principal',
            tailRotor: 'Rotor spate',
            language: 'Limbă',
        },
        mainRotor: {
            backToHome: 'Înapoi la pagina principală',
            title: 'Rotor principal',
            step: 'Pas',
            rotorIsBalanced: 'Rotorul este echilibrat!',
            vibrationBelowThreshold: 'Amplitudinea vibrațiilor ({amplitude} IPS) este sub pragul de 0.2 IPS.',
            overweightWarningTitle: 'Cavitate mică plină!',
            overweightWarningText: 'Recomandarea depășește 16g. Vă rugăm să contactați support@guimbal.com.',
            vibrationMeasurement: 'Măsurarea vibrațiilor',
            amplitudeLabel: 'Amplitudine <i>IPS</i>',
            phaseLabelHHMM: 'Fază <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grade</i>',
            phaseLabelDegreesShort: 'Grade',
            weightDistribution: 'Distribuția greutății',
            detailedWeightDistribution: 'Configurare Detaliată',
            currentlyInstalled: 'Actual',
            current: 'Actual',
            final: 'Final',
            fromPreviousStep: 'Din pasul anterior.',
            yellowBlade: 'Pală galbenă',
            greenBlade: 'Pală verde',
            redBlade: 'Pală roșie',
            recommendationAction: 'Recomandare și acțiune',
            addToCurrentlyInstalled: 'Adăugați la greutățile actuale',
            add: 'Adăugare',
            remove: 'Eliminare',
            grams: 'grame',
            recommended: 'Recomandat',
            yourAction: 'Acțiunea dvs.',
            totalWeight: 'Greutate totală',
            goToNextStep: 'Pasul următor',
            next: 'Următorul',
            goToPreviousStep: 'Pasul anterior',
            generateReport: 'Generați raport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Grafic de echilibrare',
            plotLegendRecommended: 'Vibrația actuală',
            plotLegendYourAction: 'Acțiunea dvs.',
        },
        tailRotor: {
            backToHome: 'Înapoi la pagina principală',
            title: 'Rotor spate',
            step: 'Pas',
            rotorIsBalanced: 'Rotorul este echilibrat!',
            vibrationBelowThreshold: 'Amplitudinea vibrațiilor ({amplitude} IPS) este sub pragul de 0.2 IPS.',
            vibrationMeasurement: 'Măsurarea vibrațiilor',
            amplitudeLabel: 'Amplitudine <i>IPS</i>',
            phaseLabelHHMM: 'Fază <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grade</i>',
            phaseLabelDegreesShort: 'Grade',
            installedWeights: 'Greutăți instalate',
            detailedWeightDistribution: 'Distribuția detaliată a greutății',
            detailedSetup: 'Configurare Detaliată',
            screwLabel: 'Șurub',
            smallWashers: 'Șaibe Mici',
            largeWashers: 'Șaibe Mari',
            current: 'Actual',
            final: 'Final',
            add: 'Adăugare',
            remove: 'Eliminare',
            washers: 'șaibe',
            enterWashers: 'Introduceți șaibele aflate în prezent pe rotor.',
            fromPreviousStep: '(Din pasul anterior)',
            small: 'Mic',
            large: 'Mare',
            recommendation: 'Recomandare',
            recommendationFinalSetup: 'Recomandare și configurare finală',
            recommendedFinalWashers: 'Șaibe finale recomandate (total)',
            yourFinalWasherSetup: 'Configurația dvs. finală de șaibe (total)',
            editFinalSetup: 'Editați aici pentru a corespunde șaibelor pe care le-ați instalat efectiv, dacă sunt diferite de recomandare.',
            goToNextStep: 'Pasul următor',
            next: 'Următorul',
            goToPreviousStep: 'Pasul anterior',
            generateReport: 'Generați raport PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Grafic de echilibrare',
        }
    },
    nl: {
        common: {
            resetLearning: "↺ Leren resetten",
            resetConfirm: "Heeft u de pitch links of trim tabs aangepast?\n\nDit wist de geschiedenis van eerdere stappen zodat het algoritme de nieuwe aerodynamische configuratie kan leren.\n\nWeet u het zeker?",
        },
        help: {
            pitchLinkReset: "Na aanpassingen aan bladspoor: Als u pitch links of trim tabs aanpast, verandert het gedrag van de rotor. U moet op de knop 'Leren resetten' klikken om de oude geschiedenis te wissen. De volgende run dient als een nieuwe kalibratiestap."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 Rotor Balanceringsassistent',
            mainRotor: 'Hoofdrotor',
            tailRotor: 'Achterrotor',
            language: 'Taal',
        },
        mainRotor: {
            backToHome: 'Terug naar startpagina',
            title: 'Hoofdrotor',
            step: 'Stap',
            rotorIsBalanced: 'Rotor is gebalanceerd!',
            vibrationBelowThreshold: 'Trillingsamplitude ({amplitude} IPS) is onder de drempel van 0.2 IPS.',
            overweightWarningTitle: 'Kleine holte vol!',
            overweightWarningText: 'De aanbeveling overschrijdt 16g. Neem contact op met support@guimbal.com.',
            vibrationMeasurement: 'Trillingsmeting',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>uu:mm</i>',
            phaseLabelDegrees: '<i>graden</i>',
            phaseLabelDegreesShort: 'Graden',
            weightDistribution: 'Gewichtsverdeling',
            detailedWeightDistribution: 'Gedetailleerde Instelling',
            currentlyInstalled: 'Huidig',
            current: 'Huidig',
            final: 'Definitief',
            fromPreviousStep: 'Van de vorige stap.',
            yellowBlade: 'Geel blad',
            greenBlade: 'Groen blad',
            redBlade: 'Rood blad',
            recommendationAction: 'Aanbeveling & Actie',
            addToCurrentlyInstalled: 'Toevoegen aan huidig geïnstalleerde',
            add: 'Toevoegen',
            remove: 'Verwijderen',
            grams: 'gram',
            recommended: 'Aanbevolen',
            yourAction: 'Uw actie',
            totalWeight: 'Totaal gewicht',
            goToNextStep: 'Volgende stap',
            next: 'Volgende',
            goToPreviousStep: 'Vorige stap',
            generateReport: 'PDF-rapport genereren',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balanceringsgrafiek',
            plotLegendRecommended: 'Huidige trilling',
            plotLegendYourAction: 'Uw actie',
        },
        tailRotor: {
            backToHome: 'Terug naar startpagina',
            title: 'Achterrotor',
            step: 'Stap',
            rotorIsBalanced: 'Rotor is gebalanceerd!',
            vibrationBelowThreshold: 'Trillingsamplitude ({amplitude} IPS) is onder de drempel van 0.2 IPS.',
            vibrationMeasurement: 'Trillingsmeting',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>uu:mm</i>',
            phaseLabelDegrees: '<i>graden</i>',
            phaseLabelDegreesShort: 'Graden',
            installedWeights: 'Geïnstalleerde gewichten',
            detailedWeightDistribution: 'Gedetailleerde Gewichtsverdeling',
            detailedSetup: 'Gedetailleerde Instelling',
            screwLabel: 'Schroef',
            smallWashers: 'Kleine Ringen',
            largeWashers: 'Grote Ringen',
            current: 'Huidig',
            final: 'Definitief',
            add: 'Toevoegen',
            remove: 'Verwijderen',
            washers: 'ringen',
            enterWashers: 'Voer de ringen in die momenteel op de rotor zitten.',
            fromPreviousStep: '(Van de vorige stap)',
            small: 'Klein',
            large: 'Groot',
            recommendation: 'Aanbeveling',
            recommendationFinalSetup: 'Aanbeveling & Eindconfiguratie',
            recommendedFinalWashers: 'Aanbevolen eindringen (totaal)',
            yourFinalWasherSetup: 'Uw eindconfiguratie ringen (totaal)',
            editFinalSetup: 'Bewerk hier om overeen te komen met de ringen die u daadwerkelijk hebt geïnstalleerd, als deze afwijken van de aanbeveling.',
            goToNextStep: 'Volgende stap',
            next: 'Volgende',
            goToPreviousStep: 'Vorige stap',
            generateReport: 'PDF-rapport genereren',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balanceringsgrafiek',
        }
    },
    sv: {
        common: {
            resetLearning: "↺ Återställ Inlärning",
            resetConfirm: "Har du justerat pitch links eller trim tabs?\n\nDetta rensar historiken från föregående steg så att algoritmen kan lära sig den nya aerodynamiska konfigurationen.\n\nÄr du säker?",
        },
        help: {
            pitchLinkReset: "Efter justering av bladspårning: Om du justerar pitch links eller trim tabs, ändras rotorns beteende. Du måste klicka på knappen 'Återställ Inlärning' för att rensa den gamla historiken. Nästa körning kommer att fungera som ett nytt kalibreringssteg."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Balanseringsassistent för Cabri G2-rotorer',
            mainRotor: 'Huvudrotor',
            tailRotor: 'Bakre rotor',
            language: 'Språk',
        },
        mainRotor: {
            backToHome: 'Tillbaka till startsidan',
            title: 'Huvudrotor',
            step: 'Steg',
            rotorIsBalanced: 'Rotorn är balanserad!',
            vibrationBelowThreshold: 'Vibrationsamplituden ({amplitude} IPS) är under tröskeln på 0.2 IPS.',
            overweightWarningTitle: 'Litet hålrum fullt!',
            overweightWarningText: 'Rekommendationen överskrider 16g. Vänligen kontakta support@guimbal.com.',
            vibrationMeasurement: 'Vibrationsmätning',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fas <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grader</i>',
            phaseLabelDegreesShort: 'Grader',
            weightDistribution: 'Viktfördelning',
            detailedWeightDistribution: 'Detaljerad Inställning',
            currentlyInstalled: 'Nuvarande',
            current: 'Nuvarande',
            final: 'Slutlig',
            fromPreviousStep: 'Från föregående steg.',
            yellowBlade: 'Gult blad',
            greenBlade: 'Grönt blad',
            redBlade: 'Rött blad',
            recommendationAction: 'Rekommendation & Åtgärd',
            addToCurrentlyInstalled: 'Lägg till i nuvarande installerade',
            add: 'Lägg till',
            remove: 'Ta bort',
            grams: 'gram',
            recommended: 'Rekommenderat',
            yourAction: 'Din åtgärd',
            totalWeight: 'Totalvikt',
            goToNextStep: 'Nästa steg',
            next: 'Nästa',
            goToPreviousStep: 'Föregående steg',
            generateReport: 'Generera PDF-rapport',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balanseringsdiagram',
            plotLegendRecommended: 'Nuvarande vibration',
            plotLegendYourAction: 'Din åtgärd',
        },
        tailRotor: {
            backToHome: 'Tillbaka till startsidan',
            title: 'Bakre rotor',
            step: 'Steg',
            rotorIsBalanced: 'Rotorn är balanserad!',
            vibrationBelowThreshold: 'Vibrationsamplituden ({amplitude} IPS) är under tröskeln på 0.2 IPS.',
            vibrationMeasurement: 'Vibrationsmätning',
            amplitudeLabel: 'Amplitud <i>IPS</i>',
            phaseLabelHHMM: 'Fas <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grader</i>',
            phaseLabelDegreesShort: 'Grader',
            installedWeights: 'Installerade vikter',
            detailedWeightDistribution: 'Detaljerad Viktfördelning',
            detailedSetup: 'Detaljerad Inställning',
            screwLabel: 'Skruv',
            smallWashers: 'Små Brickor',
            largeWashers: 'Stora Brickor',
            current: 'Nuvarande',
            final: 'Slutlig',
            add: 'Lägg till',
            remove: 'Ta bort',
            washers: 'brickor',
            enterWashers: 'Ange brickor som för närvarande finns på rotorn.',
            fromPreviousStep: '(Från föregående steg)',
            small: 'Liten',
            large: 'Stor',
            recommendation: 'Rekommendation',
            recommendationFinalSetup: 'Rekommendation & Slutlig inställning',
            recommendedFinalWashers: 'Rekommenderade slutliga brickor (totalt)',
            yourFinalWasherSetup: 'Din slutliga brickinställning (totalt)',
            editFinalSetup: 'Redigera här för att matcha de brickor du faktiskt installerade, om de skiljer sig från rekommendationen.',
            goToNextStep: 'Nästa steg',
            next: 'Nästa',
            goToPreviousStep: 'Föregående steg',
            generateReport: 'Generera PDF-rapport',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balanseringsdiagram',
        }
    },
    da: {
        common: {
            resetLearning: "↺ Nulstil Læring",
            resetConfirm: "Har du justeret pitch links eller trim tabs?\n\nDette vil slette historikken fra tidligere trin, så algoritmen kan lære den nye aerodynamiske konfiguration.\n\nEr du sikker?",
        },
        help: {
            pitchLinkReset: "Efter justering af bladsporing: Hvis du justerer pitch links eller trim tabs, ændres rotorens adfærd. Du skal klikke på knappen 'Nulstil Læring' for at slette den gamle historik. Næste kørsel vil fungere som et nyt kalibreringstrin."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 Rotorafbalanceringsassistent',
            mainRotor: 'Hovedrotor',
            tailRotor: 'Bagrotor',
            language: 'Sprog',
        },
        mainRotor: {
            backToHome: 'Tilbage til startside',
            title: 'Hovedrotor',
            step: 'Trin',
            rotorIsBalanced: 'Rotor er afbalanceret!',
            vibrationBelowThreshold: 'Vibrationsamplitude ({amplitude} IPS) er under tærsklen på 0,2 IPS.',
            overweightWarningTitle: 'Lille hulrum fyldt!',
            overweightWarningText: 'Anbefalingen overstiger 16g. Kontakt venligst support@guimbal.com.',
            vibrationMeasurement: 'Vibrationsmåling',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>tt:mm</i>',
            phaseLabelDegrees: '<i>grader</i>',
            phaseLabelDegreesShort: 'Grader',
            weightDistribution: 'Vægtfordeling',
            detailedWeightDistribution: 'Detaljeret Opsætning',
            currentlyInstalled: 'Aktuel',
            current: 'Aktuel',
            final: 'Endelig',
            fromPreviousStep: 'Fra forrige trin.',
            yellowBlade: 'Gult blad',
            greenBlade: 'Grønt blad',
            redBlade: 'Rødt blad',
            recommendationAction: 'Anbefaling & Handling',
            addToCurrentlyInstalled: 'Føj til aktuelt installerede',
            add: 'Tilføj',
            remove: 'Fjern',
            grams: 'gram',
            recommended: 'Anbefalet',
            yourAction: 'Din handling',
            totalWeight: 'Totalvægt',
            goToNextStep: 'Næste trin',
            next: 'Næste',
            goToPreviousStep: 'Forrige trin',
            generateReport: 'Generer PDF-rapport',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Afbalanceringsplot',
            plotLegendRecommended: 'Aktuel vibration',
            plotLegendYourAction: 'Din handling',
        },
        tailRotor: {
            backToHome: 'Tilbage til startside',
            title: 'Bagrotor',
            step: 'Trin',
            rotorIsBalanced: 'Rotor er afbalanceret!',
            vibrationBelowThreshold: 'Vibrationsamplitude ({amplitude} IPS) er under tærsklen på 0,2 IPS.',
            vibrationMeasurement: 'Vibrationsmåling',
            amplitudeLabel: 'Amplitude <i>IPS</i>',
            phaseLabelHHMM: 'Fase <i>tt:mm</i>',
            phaseLabelDegrees: '<i>grader</i>',
            phaseLabelDegreesShort: 'Grader',
            installedWeights: 'Installerede vægte',
            detailedWeightDistribution: 'Detaljeret Vægtfordeling',
            detailedSetup: 'Detaljeret Opsætning',
            screwLabel: 'Skrue',
            smallWashers: 'Små Skiver',
            largeWashers: 'Store Skiver',
            current: 'Aktuel',
            final: 'Endelig',
            add: 'Tilføj',
            remove: 'Fjern',
            washers: 'skiver',
            enterWashers: 'Indtast skiver, der i øjeblikket er på rotoren.',
            fromPreviousStep: '(Fra forrige trin)',
            small: 'Lille',
            large: 'Stor',
            recommendation: 'Anbefaling',
            recommendationFinalSetup: 'Anbefaling & Endelig opsætning',
            recommendedFinalWashers: 'Anbefalede endelige skiver (i alt)',
            yourFinalWasherSetup: 'Din endelige skiveopsætning (i alt)',
            editFinalSetup: 'Rediger her for at matche de skiver, du rent faktisk installerede, hvis de adskiller sig fra anbefalingen.',
            goToNextStep: 'Næste trin',
            next: 'Næste',
            goToPreviousStep: 'Forrige trin',
            generateReport: 'Generer PDF-rapport',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Afbalanceringsplot',
        }
    },
    fi: {
        common: {
            resetLearning: "↺ Nollaa Oppiminen",
            resetConfirm: "Oletko säätänyt lapakulmatankoja (pitch links) tai säätölevyjä (trim tabs)?\n\nTämä tyhjentää aiempien vaiheiden historian, jotta algoritmi voi oppia uuden aerodynaamisen konfiguraation.\n\nOletko varma?",
        },
        help: {
            pitchLinkReset: "Lapaseurannan säätämisen jälkeen: Jos säädät lapakulmatankoja tai säätölevyjä, roottorin käyttäytyminen muuttuu. Sinun on napsautettava 'Nollaa Oppiminen' -painiketta tyhjentääksesi vanhan historian. Seuraava ajo toimii uutena kalibrointivaiheena."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 -roottorin tasapainotusavustaja',
            mainRotor: 'Pääroottori',
            tailRotor: 'Takaroottori',
            language: 'Kieli',
        },
        mainRotor: {
            backToHome: 'Takaisin etusivulle',
            title: 'Pääroottori',
            step: 'Vaihe',
            rotorIsBalanced: 'Roottori on tasapainossa!',
            vibrationBelowThreshold: 'Värähtelyn amplitudi ({amplitude} IPS) on alle 0,2 IPS:n kynnyksen.',
            overweightWarningTitle: 'Pieni ontelo täynnä!',
            overweightWarningText: 'Suositus ylittää 16g. Ota yhteyttä support@guimbal.com.',
            vibrationMeasurement: 'Värähtelyn mittaus',
            amplitudeLabel: 'Amplitudi <i>IPS</i>',
            phaseLabelHHMM: 'Vaihe <i>hh:mm</i>',
            phaseLabelDegrees: '<i>astetta</i>',
            phaseLabelDegreesShort: 'Asteet',
            weightDistribution: 'Painonjakauma',
            detailedWeightDistribution: 'Yksityiskohtainen Asetus',
            currentlyInstalled: 'Nykyinen',
            current: 'Nykyinen',
            final: 'Lopullinen',
            fromPreviousStep: 'Edellisestä vaiheesta.',
            yellowBlade: 'Keltainen lapa',
            greenBlade: 'Vihreä lapa',
            redBlade: 'Punainen lapa',
            recommendationAction: 'Suositus & Toimenpide',
            addToCurrentlyInstalled: 'Lisää nykyisiin asennettuihin',
            add: 'Lisää',
            remove: 'Poista',
            grams: 'grammaa',
            recommended: 'Suositeltu',
            yourAction: 'Sinun toimenpiteesi',
            totalWeight: 'Kokonaispaino',
            goToNextStep: 'Seuraava vaihe',
            next: 'Seuraava',
            goToPreviousStep: 'Edellinen vaihe',
            generateReport: 'Luo PDF-raportti',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Tasapainotuskaavio',
            plotLegendRecommended: 'Nykyinen värähtely',
            plotLegendYourAction: 'Sinun toimenpiteesi',
        },
        tailRotor: {
            backToHome: 'Takaisin etusivulle',
            title: 'Takaroottori',
            step: 'Vaihe',
            rotorIsBalanced: 'Roottori on tasapainossa!',
            vibrationBelowThreshold: 'Värähtelyn amplitudi ({amplitude} IPS) on alle 0,2 IPS:n kynnyksen.',
            vibrationMeasurement: 'Värähtelyn mittaus',
            amplitudeLabel: 'Amplitudi <i>IPS</i>',
            phaseLabelHHMM: 'Vaihe <i>hh:mm</i>',
            phaseLabelDegrees: '<i>astetta</i>',
            phaseLabelDegreesShort: 'Asteet',
            installedWeights: 'Asennetut painot',
            detailedWeightDistribution: 'Yksityiskohtainen Painonjakauma',
            detailedSetup: 'Yksityiskohtainen Asetus',
            screwLabel: 'Ruuvi',
            smallWashers: 'Pienet Aluslevyt',
            largeWashers: 'Suuret Aluslevyt',
            current: 'Nykyinen',
            final: 'Lopullinen',
            add: 'Lisää',
            remove: 'Poista',
            washers: 'aluslevyt',
            enterWashers: 'Syötä aluslevyt, jotka ovat tällä hetkellä roottorissa.',
            fromPreviousStep: '(Edellisestä vaiheesta)',
            small: 'Pieni',
            large: 'Suuri',
            recommendation: 'Suositus',
            recommendationFinalSetup: 'Suositus & Lopullinen asetus',
            recommendedFinalWashers: 'Suositellut lopulliset aluslevyt (yhteensä)',
            yourFinalWasherSetup: 'Oma lopullinen aluslevyasetuksesi (yhteensä)',
            editFinalSetup: 'Muokkaa tästä vastaamaan aluslevyjä, jotka todella asensit, jos ne eroavat suosituksesta.',
            goToNextStep: 'Seuraava vaihe',
            next: 'Seuraava',
            goToPreviousStep: 'Edellinen vaihe',
            generateReport: 'Luo PDF-raportti',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Tasapainotuskaavio',
        }
    },
    uk: {
        common: {
            resetLearning: "↺ Скинути навчання",
            resetConfirm: "Ви регулювали тяги кроку (pitch links) або тримери (trim tabs)?\n\nЦе очистить історію попередніх кроків, щоб алгоритм міг вивчити нову аеродинамічну конфігурацію.\n\nВи впевнені?",
        },
        help: {
            pitchLinkReset: "Після регулювання співвісності лопатей: Якщо ви регулюєте тяги кроку або тримери, поведінка ротора змінюється. Ви повинні натиснути кнопку 'Скинути навчання', щоб очистити стару історію. Наступний запуск слугуватиме новим етапом калібрування."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Асистент з балансування роторів Cabri G2',
            mainRotor: 'Головний ротор',
            tailRotor: 'Задній ротор',
            language: 'Мова',
        },
        mainRotor: {
            backToHome: 'Повернутися на головну',
            title: 'Головний ротор',
            step: 'Крок',
            rotorIsBalanced: 'Ротор збалансовано!',
            vibrationBelowThreshold: 'Амплітуда вібрації ({amplitude} IPS) нижча за поріг 0.2 IPS.',
            overweightWarningTitle: 'Мала порожнина заповнена!',
            overweightWarningText: 'Рекомендація перевищує 16 г. Будь ласка, зверніться до support@guimbal.com.',
            vibrationMeasurement: 'Вимірювання вібрації',
            amplitudeLabel: 'Амплітуда <i>IPS</i>',
            phaseLabelHHMM: 'Фаза <i>гг:хх</i>',
            phaseLabelDegrees: '<i>градуси</i>',
            phaseLabelDegreesShort: 'Градуси',
            weightDistribution: 'Розподіл ваги',
            detailedWeightDistribution: 'Детальне налаштування',
            currentlyInstalled: 'Поточний',
            current: 'Поточний',
            final: 'Кінцевий',
            fromPreviousStep: 'З попереднього кроку.',
            yellowBlade: 'Жовта лопать',
            greenBlade: 'Зелена лопать',
            redBlade: 'Червона лопать',
            recommendationAction: 'Рекомендація та дія',
            addToCurrentlyInstalled: 'Додати до встановлених',
            add: 'Додати',
            remove: 'Видалити',
            grams: 'грами',
            recommended: 'Рекомендовано',
            yourAction: 'Ваша дія',
            totalWeight: 'Загальна вага',
            goToNextStep: 'Наступний крок',
            next: 'Далі',
            goToPreviousStep: 'Попередній крок',
            generateReport: 'Створити PDF-звіт',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Графік балансування',
            plotLegendRecommended: 'Поточна вібрація',
            plotLegendYourAction: 'Ваша дія',
        },
        tailRotor: {
            backToHome: 'Повернутися на головну',
            title: 'Задній ротор',
            step: 'Крок',
            rotorIsBalanced: 'Ротор збалансовано!',
            vibrationBelowThreshold: 'Амплітуда вібрації ({amplitude} IPS) нижча за поріг 0.2 IPS.',
            vibrationMeasurement: 'Вимірювання вібрації',
            amplitudeLabel: 'Амплітуда <i>IPS</i>',
            phaseLabelHHMM: 'Фаза <i>гг:хх</i>',
            phaseLabelDegrees: '<i>градуси</i>',
            phaseLabelDegreesShort: 'Градуси',
            installedWeights: 'Встановлені вантажі',
            detailedWeightDistribution: 'Детальний розподіл ваги',
            detailedSetup: 'Детальне налаштування',
            screwLabel: 'Гвинт',
            smallWashers: 'Малі Шайби',
            largeWashers: 'Великі Шайби',
            current: 'Поточний',
            final: 'Кінцевий',
            add: 'Додати',
            remove: 'Видалити',
            washers: 'шайби',
            enterWashers: 'Введіть шайби, що зараз на роторі.',
            fromPreviousStep: '(З попереднього кроку)',
            small: 'Мала',
            large: 'Велика',
            recommendation: 'Рекомендація',
            recommendationFinalSetup: 'Рекомендація та остаточне налаштування',
            recommendedFinalWashers: 'Рекомендовані фінальні шайби (загалом)',
            yourFinalWasherSetup: 'Ваше фінальне налаштування шайб (загалом)',
            editFinalSetup: 'Відредагуйте тут, щоб відповідало шайбам, які ви фактично встановили, якщо вони відрізняються від рекомендації.',
            goToNextStep: 'Наступний крок',
            next: 'Далі',
            goToPreviousStep: 'Попередній крок',
            generateReport: 'Створити PDF-звіт',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Графік балансування',
        }
    },
    he: {
        common: {
            resetLearning: "↺ אפס למידה",
            resetConfirm: "האם כיוונת את ה-pitch links או ה-trim tabs?\n\nפעולה זו תמחק את ההיסטוריה של השלבים הקודמים כדי שהאלגוריתם יוכל ללמוד את התצורה האווירודינמית החדשה.\n\nהאם אתה בטוח?",
        },
        help: {
            pitchLinkReset: "לאחר כיוון עקיבת להב: אם אתה מכוון את ה-pitch links או ה-trim tabs, התנהגות הרוטור משתנה. עליך ללחוץ על כפתור 'אפס למידה' כדי למחוק את ההיסטוריה הישנה. ההרצה הבאה תשמש כשלב כיול חדש."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'עוזר איזון רוטורים של Cabri G2',
            mainRotor: 'רוטור ראשי',
            tailRotor: 'רוטור אחורי',
            language: 'שפה',
        },
        mainRotor: {
            backToHome: 'חזרה לדף הבית',
            title: 'רוטור ראשי',
            step: 'שלב',
            rotorIsBalanced: 'הרוטור מאוזן!',
            vibrationBelowThreshold: 'משרעת הרטט ({amplitude} IPS) נמוכה מהסף של 0.2 IPS.',
            overweightWarningTitle: 'חלל קטן מלא!',
            overweightWarningText: 'ההמלצה חורגת מ-16 גרם. אנא פנה ל-support@guimbal.com.',
            vibrationMeasurement: 'מדידת רטט',
            amplitudeLabel: 'משרעת <i>IPS</i>',
            phaseLabelHHMM: 'פאזה <i>שש:דד</i>',
            phaseLabelDegrees: '<i>מעלות</i>',
            phaseLabelDegreesShort: 'מעלות',
            weightDistribution: 'פיזור משקל',
            detailedWeightDistribution: 'הגדרה מפורטת',
            currentlyInstalled: 'נוכחי',
            current: 'נוכחי',
            final: 'סופי',
            fromPreviousStep: 'מהשלב הקודם.',
            yellowBlade: 'להב צהוב',
            greenBlade: 'להב ירוק',
            redBlade: 'להב אדום',
            recommendationAction: 'המלצה ופעולה',
            addToCurrentlyInstalled: 'הוסף למותקנות כעת',
            add: 'הוסף',
            remove: 'הסר',
            grams: 'גרם',
            recommended: 'מומלץ',
            yourAction: 'הפעולה שלך',
            totalWeight: 'משקל כולל',
            goToNextStep: 'השלב הבא',
            next: 'הבא',
            goToPreviousStep: 'השלב הקודם',
            generateReport: 'הפק דוח PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'גרף איזון',
            plotLegendRecommended: 'רטט נוכחי',
            plotLegendYourAction: 'הפעולה שלך',
        },
        tailRotor: {
            backToHome: 'חזרה לדף הבית',
            title: 'רוטור אחורי',
            step: 'שלב',
            rotorIsBalanced: 'הרוטור מאוזן!',
            vibrationBelowThreshold: 'משרעת הרטט ({amplitude} IPS) נמוכה מהסף של 0.2 IPS.',
            vibrationMeasurement: 'מדידת רטט',
            amplitudeLabel: 'משרעת <i>IPS</i>',
            phaseLabelHHMM: 'פאזה <i>שש:דד</i>',
            phaseLabelDegrees: '<i>מעלות</i>',
            phaseLabelDegreesShort: 'מעלות',
            installedWeights: 'משקולות מותקנות',
            detailedWeightDistribution: 'פיזור משקל מפורט',
            detailedSetup: 'הגדרה מפורטת',
            screwLabel: 'בורג',
            smallWashers: 'דסקיות קטנות',
            largeWashers: 'דסקיות גדולות',
            current: 'נוכחי',
            final: 'סופי',
            add: 'הוסף',
            remove: 'הסר',
            washers: 'דסקיות',
            enterWashers: 'הזן את הדסקיות שנמצאות כעת על הרוטור.',
            fromPreviousStep: '(מהשלב הקודם)',
            small: 'קטנה',
            large: 'גדולה',
            recommendation: 'המלצה',
            recommendationFinalSetup: 'המלצה והגדרה סופית',
            recommendedFinalWashers: 'דסקיות סופיות מומלצות (סה"כ)',
            yourFinalWasherSetup: 'הגדרת הדסקיות הסופית שלך (סה"כ)',
            editFinalSetup: 'ערוך כאן כדי להתאים לדסקיות שהתקנת בפועל, אם הן שונות מההמלצה.',
            goToNextStep: 'השלב הבא',
            next: 'הבא',
            goToPreviousStep: 'השלב הקודם',
            generateReport: 'הפק דוח PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'גרף איזון',
        }
    },
    vi: {
        common: {
            resetLearning: "↺ Đặt lại Học tập",
            resetConfirm: "Bạn đã điều chỉnh pitch links hoặc trim tabs chưa?\n\nViệc này sẽ xóa lịch sử các bước trước đó để thuật toán có thể học cấu hình khí động học mới.\n\nBạn có chắc chắn không?",
        },
        help: {
            pitchLinkReset: "Sau khi điều chỉnh tracking cánh: Nếu bạn điều chỉnh pitch links hoặc trim tabs, hành vi của rô-to sẽ thay đổi. Bạn phải nhấp vào nút 'Đặt lại Học tập' để xóa lịch sử cũ. Lần chạy tiếp theo sẽ đóng vai trò là một bước hiệu chuẩn mới."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Trợ lý Cân bằng Rô-to Cabri G2',
            mainRotor: 'Rô-to chính',
            tailRotor: 'Rô-to sau',
            language: 'Ngôn ngữ',
        },
        mainRotor: {
            backToHome: 'Quay lại Trang chủ',
            title: 'Rô-to chính',
            step: 'Bước',
            rotorIsBalanced: 'Rô-to đã được cân bằng!',
            vibrationBelowThreshold: 'Biên độ rung ({amplitude} IPS) dưới ngưỡng 0.2 IPS.',
            overweightWarningTitle: 'Khoang nhỏ đã đầy!',
            overweightWarningText: 'Khuyến nghị vượt quá 16g. Vui lòng liên hệ support@guimbal.com.',
            vibrationMeasurement: 'Đo lường rung động',
            amplitudeLabel: 'Biên độ <i>IPS</i>',
            phaseLabelHHMM: 'Pha <i>hh:mm</i>',
            phaseLabelDegrees: '<i>độ</i>',
            phaseLabelDegreesShort: 'Độ',
            weightDistribution: 'Phân bổ trọng lượng',
            detailedWeightDistribution: 'Thiết lập Chi tiết',
            currentlyInstalled: 'Hiện tại',
            current: 'Hiện tại',
            final: 'Cuối cùng',
            fromPreviousStep: 'Từ bước trước.',
            yellowBlade: 'Cánh màu vàng',
            greenBlade: 'Cánh màu xanh lá',
            redBlade: 'Cánh màu đỏ',
            recommendationAction: 'Khuyến nghị & Hành động',
            addToCurrentlyInstalled: 'Thêm vào trọng lượng hiện tại',
            add: 'Thêm',
            remove: 'Bớt',
            grams: 'gam',
            recommended: 'Đề nghị',
            yourAction: 'Hành động của bạn',
            totalWeight: 'Tổng trọng lượng',
            goToNextStep: 'Bước tiếp theo',
            next: 'Tiếp',
            goToPreviousStep: 'Bước trước',
            generateReport: 'Tạo Báo cáo PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Biểu đồ Cân bằng',
            plotLegendRecommended: 'Rung động hiện tại',
            plotLegendYourAction: 'Hành động của bạn',
        },
        tailRotor: {
            backToHome: 'Quay lại Trang chủ',
            title: 'Rô-to sau',
            step: 'Bước',
            rotorIsBalanced: 'Rô-to đã được cân bằng!',
            vibrationBelowThreshold: 'Biên độ rung ({amplitude} IPS) dưới ngưỡng 0.2 IPS.',
            vibrationMeasurement: 'Đo lường rung động',
            amplitudeLabel: 'Biên độ <i>IPS</i>',
            phaseLabelHHMM: 'Pha <i>hh:mm</i>',
            phaseLabelDegrees: '<i>độ</i>',
            phaseLabelDegreesShort: 'Độ',
            installedWeights: 'Trọng lượng đã lắp đặt',
            detailedWeightDistribution: 'Phân bổ trọng lượng chi tiết',
            detailedSetup: 'Thiết lập Chi tiết',
            screwLabel: 'Vít',
            smallWashers: 'Vòng Đệm Nhỏ',
            largeWashers: 'Vòng Đệm Lớn',
            current: 'Hiện tại',
            final: 'Cuối cùng',
            add: 'Thêm',
            remove: 'Bớt',
            washers: 'vòng đệm',
            enterWashers: 'Nhập các vòng đệm hiện có trên rô-to.',
            fromPreviousStep: '(Từ bước trước)',
            small: 'Nhỏ',
            large: 'Lớn',
            recommendation: 'Khuyến nghị',
            recommendationFinalSetup: 'Khuyến nghị & Thiết lập cuối cùng',
            recommendedFinalWashers: 'Vòng đệm cuối cùng được khuyến nghị (tổng)',
            yourFinalWasherSetup: 'Thiết lập vòng đệm cuối cùng của bạn (tổng)',
            editFinalSetup: 'Chỉnh sửa ở đây để khớp với các vòng đệm bạn đã lắp đặt thực tế, nếu khác với khuyến nghị.',
            goToNextStep: 'Bước tiếp theo',
            next: 'Tiếp',
            goToPreviousStep: 'Bước trước',
            generateReport: 'Tạo Báo cáo PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Biểu đồ Cân bằng',
        }
    },
    et: {
        common: {
            resetLearning: "↺ Lähtesta Õppimine",
            resetConfirm: "Kas olete reguleerinud pitch linke või trimmitabeleid?\n\nSee kustutab eelmiste sammude ajaloo, et algoritm saaks õppida uut aerodünaamilist konfiguratsiooni.\n\nKas olete kindel?",
        },
        help: {
            pitchLinkReset: "Pärast labade jälgimise reguleerimist: Kui reguleerite pitch linke või trimmitabeleid, muutub rootori käitumine. Peate klõpsama nuppu 'Lähtesta Õppimine', et kustutada vana ajalugu. Järgmine käivitus toimib uue kalibreerimissammuna."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 rootori tasakaalustamise abiline',
            mainRotor: 'Pearootor',
            tailRotor: 'Tagumine rootor',
            language: 'Keel',
        },
        mainRotor: {
            backToHome: 'Tagasi avalehele',
            title: 'Pearootor',
            step: 'Samm',
            rotorIsBalanced: 'Rootor on tasakaalus!',
            vibrationBelowThreshold: 'Vibratsiooni amplituud ({amplitude} IPS) on alla 0,2 IPS läve.',
            overweightWarningTitle: 'Väike õõnsus on täis!',
            overweightWarningText: 'Soovitus ületab 16g. Palun võtke ühendust aadressil support@guimbal.com.',
            vibrationMeasurement: 'Vibratsiooni mõõtmine',
            amplitudeLabel: 'Amplituud <i>IPS</i>',
            phaseLabelHHMM: 'Faas <i>hh:mm</i>',
            phaseLabelDegrees: '<i>kraadi</i>',
            phaseLabelDegreesShort: 'Kraadid',
            weightDistribution: 'Kaalujaotus',
            detailedWeightDistribution: 'Detailne Seadistus',
            currentlyInstalled: 'Praegune',
            current: 'Praegune',
            final: 'Lõplik',
            fromPreviousStep: 'Eelmisest sammust.',
            yellowBlade: 'Kollane laba',
            greenBlade: 'Roheline laba',
            redBlade: 'Punane laba',
            recommendationAction: 'Soovitus ja tegevus',
            addToCurrentlyInstalled: 'Lisa praegustele raskustele',
            add: 'Lisa',
            remove: 'Eemalda',
            grams: 'grammi',
            recommended: 'Soovitatav',
            yourAction: 'Teie tegevus',
            totalWeight: 'Kogukaal',
            goToNextStep: 'Järgmine samm',
            next: 'Järgmine',
            goToPreviousStep: 'Eelmine samm',
            generateReport: 'Genereeri PDF-aruanne',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Tasakaalustamise graafik',
            plotLegendRecommended: 'Praegune vibratsioon',
            plotLegendYourAction: 'Teie tegevus',
        },
        tailRotor: {
            backToHome: 'Tagasi avalehele',
            title: 'Tagumine rootor',
            step: 'Samm',
            rotorIsBalanced: 'Rootor on tasakaalus!',
            vibrationBelowThreshold: 'Vibratsiooni amplituud ({amplitude} IPS) on alla 0,2 IPS läve.',
            vibrationMeasurement: 'Vibratsiooni mõõtmine',
            amplitudeLabel: 'Amplituud <i>IPS</i>',
            phaseLabelHHMM: 'Faas <i>hh:mm</i>',
            phaseLabelDegrees: '<i>kraadi</i>',
            phaseLabelDegreesShort: 'Kraadid',
            installedWeights: 'Paigaldatud raskused',
            detailedWeightDistribution: 'Detailne Kaalujaotus',
            detailedSetup: 'Detailne Seadistus',
            screwLabel: 'Kruvi',
            smallWashers: 'Väikesed Seibid',
            largeWashers: 'Suured Seibid',
            current: 'Praegune',
            final: 'Lõplik',
            add: 'Lisa',
            remove: 'Eemalda',
            washers: 'seibid',
            enterWashers: 'Sisestage seibid, mis on praegu rootoril.',
            fromPreviousStep: '(Eelmisest sammust)',
            small: 'Väike',
            large: 'Suur',
            recommendation: 'Soovitus',
            recommendationFinalSetup: 'Soovitus ja lõplik seadistus',
            recommendedFinalWashers: 'Soovitatavad lõplikud seibid (kokku)',
            yourFinalWasherSetup: 'Teie lõplik seibide seadistus (kokku)',
            editFinalSetup: 'Muutke siin, et see vastaks tegelikult paigaldatud seibidele, kui need erinevad soovitusest.',
            goToNextStep: 'Järgmine samm',
            next: 'Järgmine',
            goToPreviousStep: 'Eelmine samm',
            generateReport: 'Genereeri PDF-aruanne',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Tasakaalustamise graafik',
        }
    },
    lv: {
        common: {
            resetLearning: "↺ Atiestatīt Mācīšanos",
            resetConfirm: "Vai esat pielāgojis pitch links vai trim tabs?\n\nTas izdzēsīs iepriekšējo soļu vēsturi, lai algoritms varētu apgūt jauno aerodinamisko konfigurāciju.\n\nVai esat pārliecināts?",
        },
        help: {
            pitchLinkReset: "Pēc lāpstiņu sekošanas pielāgošanas: Ja pielāgojat pitch links vai trim tabs, rotora uzvedība mainās. Jums jānoklikšķina uz pogas 'Atiestatīt Mācīšanos', lai izdzēstu veco vēsturi. Nākamā palaišana kalpos kā jauns kalibrēšanas solis."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 rotora balansēšanas palīgs',
            mainRotor: 'Galvenais rotors',
            tailRotor: 'Aizmugurējais rotors',
            language: 'Valoda',
        },
        mainRotor: {
            backToHome: 'Atpakaļ uz sākumlapu',
            title: 'Galvenais rotors',
            step: 'Solis',
            rotorIsBalanced: 'Rotors ir nobalansēts!',
            vibrationBelowThreshold: 'Vibrācijas amplitūda ({amplitude} IPS) ir zem 0,2 IPS sliekšņa.',
            overweightWarningTitle: 'Mazais dobums pilns!',
            overweightWarningText: 'Ieteikums pārsniedz 16g. Lūdzu, sazinieties ar support@guimbal.com.',
            vibrationMeasurement: 'Vibrācijas mērīšana',
            amplitudeLabel: 'Amplitūda <i>IPS</i>',
            phaseLabelHHMM: 'Fāze <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grādi</i>',
            phaseLabelDegreesShort: 'Grādi',
            weightDistribution: 'Svara sadalījums',
            detailedWeightDistribution: 'Detalizēta Iestatīšana',
            currentlyInstalled: 'Pašreizējais',
            current: 'Pašreizējais',
            final: 'Gala',
            fromPreviousStep: 'No iepriekšējā soļa.',
            yellowBlade: 'Dzeltenā lāpstiņa',
            greenBlade: 'Zaļā lāpstiņa',
            redBlade: 'Sarkanā lāpstiņa',
            recommendationAction: 'Ieteikums un darbība',
            addToCurrentlyInstalled: 'Pievienot pašreizējiem svariem',
            add: 'Pievienot',
            remove: 'Noņemt',
            grams: 'grami',
            recommended: 'Ieteicams',
            yourAction: 'Jūsu darbība',
            totalWeight: 'Kopējais svars',
            goToNextStep: 'Nākamais solis',
            next: 'Tālāk',
            goToPreviousStep: 'Iepriekšējais solis',
            generateReport: 'Ģenerēt PDF pārskatu',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balansēšanas grafiks',
            plotLegendRecommended: 'Pašreizējā vibrācija',
            plotLegendYourAction: 'Jūsu darbība',
        },
        tailRotor: {
            backToHome: 'Atpakaļ uz sākumlapu',
            title: 'Aizmugurējais rotors',
            step: 'Solis',
            rotorIsBalanced: 'Rotors ir nobalansēts!',
            vibrationBelowThreshold: 'Vibrācijas amplitūda ({amplitude} IPS) ir zem 0,2 IPS sliekšņa.',
            vibrationMeasurement: 'Vibrācijas mērīšana',
            amplitudeLabel: 'Amplitūda <i>IPS</i>',
            phaseLabelHHMM: 'Fāze <i>hh:mm</i>',
            phaseLabelDegrees: '<i>grādi</i>',
            phaseLabelDegreesShort: 'Grādi',
            installedWeights: 'Uzstādītie svari',
            detailedWeightDistribution: 'Detalizēts svara sadalījums',
            detailedSetup: 'Detalizēta Iestatīšana',
            screwLabel: 'Skrūve',
            smallWashers: 'Mazas Paplāksnes',
            largeWashers: 'Lielas Paplāksnes',
            current: 'Pašreizējais',
            final: 'Gala',
            add: 'Pievienot',
            remove: 'Noņemt',
            washers: 'paplāksnes',
            enterWashers: 'Ievadiet paplāksnes, kas pašlaik atrodas uz rotora.',
            fromPreviousStep: '(No iepriekšējā soļa)',
            small: 'Maza',
            large: 'Liela',
            recommendation: 'Ieteikums',
            recommendationFinalSetup: 'Ieteikums un galīgā iestatīšana',
            recommendedFinalWashers: 'Ieteicamās galīgās paplāksnes (kopā)',
            yourFinalWasherSetup: 'Jūsu galīgā paplākšņu iestatīšana (kopā)',
            editFinalSetup: 'Rediģējiet šeit, lai atbilstu faktiski uzstādītajām paplāksnēm, ja tās atšķiras no ieteikuma.',
            goToNextStep: 'Nākamais solis',
            next: 'Tālāk',
            goToPreviousStep: 'Iepriekšējais solis',
            generateReport: 'Ģenerēt PDF pārskatu',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balansēšanas grafiks',
        }
    },
    lt: {
        common: {
            resetLearning: "↺ Iš naujo nustatyti mokymąsi",
            resetConfirm: "Ar sureguliavote pitch links arba trim tabs?\n\nTai išvalys ankstesnių žingsnių istoriją, kad algoritmas galėtų išmokti naują aerodinaminę konfigūraciją.\n\nAr tikrai?",
        },
        help: {
            pitchLinkReset: "Po menčių sekimo reguliavimo: Jei sureguliuojate pitch links arba trim tabs, rotoriaus elgsena pasikeičia. Turite spustelėti mygtuką 'Iš naujo nustatyti mokymąsi', kad išvalytumėte seną istoriją. Kitas paleidimas bus naujas kalibravimo žingsnis."
        },
        home: {
            title: 'G-Tune',
            subtitle: '„Cabri G2“ rotoriaus balansavimo asistentas',
            mainRotor: 'Pagrindinis rotorius',
            tailRotor: 'Galinis rotorius',
            language: 'Kalba',
        },
        mainRotor: {
            backToHome: 'Grįžti į pagrindinį puslapį',
            title: 'Pagrindinis rotorius',
            step: 'Žingsnis',
            rotorIsBalanced: 'Rotorius subalansuotas!',
            vibrationBelowThreshold: 'Vibracijos amplitudė ({amplitude} IPS) yra mažesnė už 0,2 IPS slenkstį.',
            overweightWarningTitle: 'Maža ertmė pilna!',
            overweightWarningText: 'Rekomendacija viršija 16 g. Prašome susisiekti su support@guimbal.com.',
            vibrationMeasurement: 'Vibracijos matavimas',
            amplitudeLabel: 'Amplitudė <i>IPS</i>',
            phaseLabelHHMM: 'Fazė <i>hh:mm</i>',
            phaseLabelDegrees: '<i>laipsniai</i>',
            phaseLabelDegreesShort: 'Laipsniai',
            weightDistribution: 'Svorio paskirstymas',
            detailedWeightDistribution: 'Išsami Sąranka',
            currentlyInstalled: 'Esamas',
            current: 'Esamas',
            final: 'Galutinis',
            fromPreviousStep: 'Iš ankstesnio žingsnio.',
            yellowBlade: 'Geltona mentė',
            greenBlade: 'Žalia mentė',
            redBlade: 'Raudona mentė',
            recommendationAction: 'Rekomendacija ir veiksmas',
            addToCurrentlyInstalled: 'Pridėti prie šiuo metu sumontuotų',
            add: 'Pridėti',
            remove: 'Pašalinti',
            grams: 'gramai',
            recommended: 'Rekomenduojama',
            yourAction: 'Jūsų veiksmas',
            totalWeight: 'Bendras svoris',
            goToNextStep: 'Kitas žingsnis',
            next: 'Kitas',
            goToPreviousStep: 'Ankstesnis žingsnis',
            generateReport: 'Generuoti PDF ataskaitą',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balansavimo diagrama',
            plotLegendRecommended: 'Esama vibracija',
            plotLegendYourAction: 'Jūsų veiksmas',
        },
        tailRotor: {
            backToHome: 'Grįžti į pagrindinį puslapį',
            title: 'Galinis rotorius',
            step: 'Žingsnis',
            rotorIsBalanced: 'Rotorius subalansuotas!',
            vibrationBelowThreshold: 'Vibracijos amplitudė ({amplitude} IPS) yra mažesnė už 0,2 IPS slenkstį.',
            vibrationMeasurement: 'Vibracijos matavimas',
            amplitudeLabel: 'Amplitudė <i>IPS</i>',
            phaseLabelHHMM: 'Fazė <i>hh:mm</i>',
            phaseLabelDegrees: '<i>laipsniai</i>',
            phaseLabelDegreesShort: 'Laipsniai',
            installedWeights: 'Sumontuoti svoriai',
            detailedWeightDistribution: 'Išsamus svorio paskirstymas',
            detailedSetup: 'Išsami Sąranka',
            screwLabel: 'Sraigtas',
            smallWashers: 'Mažos Poveržlės',
            largeWashers: 'Didelės Poveržlės',
            current: 'Esamas',
            final: 'Galutinis',
            add: 'Pridėti',
            remove: 'Pašalinti',
            washers: 'poveržlės',
            enterWashers: 'Įveskite poveržles, esančias ant rotoriaus.',
            fromPreviousStep: '(Iš ankstesnio žingsnio)',
            small: 'Maža',
            large: 'Didelė',
            recommendation: 'Rekomendacija',
            recommendationFinalSetup: 'Rekomendacija ir galutinė sąranka',
            recommendedFinalWashers: 'Rekomenduojamos galutinės poveržlės (iš viso)',
            yourFinalWasherSetup: 'Jūsų galutinė poveržlių sąranka (iš viso)',
            editFinalSetup: 'Redaguokite čia, kad atitiktų faktiškai sumontuotas poveržles, jei jos skiriasi nuo rekomendacijos.',
            goToNextStep: 'Kitas žingsnis',
            next: 'Kitas',
            goToPreviousStep: 'Ankstesnis žingsnis',
            generateReport: 'Generuoti PDF ataskaitą',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Balansavimo diagrama',
        }
    },
    sl: {
        common: {
            resetLearning: "↺ Ponastavi Učenje",
            resetConfirm: "Ali ste prilagodili pitch links ali trim tabs?\n\nTo bo izbrisalo zgodovino prejšnjih korakov, da se bo algoritem lahko naučil nove aerodinamične konfiguracije.\n\nAli ste prepričani?",
        },
        help: {
            pitchLinkReset: "Po prilagoditvi sledenja lopatic: Če prilagodite pitch links ali trim tabs, se obnašanje rotorja spremeni. Klikniti morate gumb 'Ponastavi Učenje', da izbrišete staro zgodovino. Naslednji zagon bo služil kot nov kalibracijski korak."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Pomočnik za uravnoteženje rotorjev Cabri G2',
            mainRotor: 'Glavni rotor',
            tailRotor: 'Zadnji rotor',
            language: 'Jezik',
        },
        mainRotor: {
            backToHome: 'Nazaj na domačo stran',
            title: 'Glavni rotor',
            step: 'Korak',
            rotorIsBalanced: 'Rotor je uravnotežen!',
            vibrationBelowThreshold: 'Amplituda vibracij ({amplitude} IPS) je pod pragom 0,2 IPS.',
            overweightWarningTitle: 'Majhna votlina polna!',
            overweightWarningText: 'Priporočilo presega 16g. Prosimo, obrnite se na support@guimbal.com.',
            vibrationMeasurement: 'Merjenje vibracij',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Faza <i>uu:mm</i>',
            phaseLabelDegrees: '<i>stopinje</i>',
            phaseLabelDegreesShort: 'Stopinje',
            weightDistribution: 'Porazdelitev teže',
            detailedWeightDistribution: 'Podrobna Nastavitev',
            currentlyInstalled: 'Trenutno',
            current: 'Trenutno',
            final: 'Končno',
            fromPreviousStep: 'Iz prejšnjega koraka.',
            yellowBlade: 'Rumena lopatica',
            greenBlade: 'Zelena lopatica',
            redBlade: 'Rdeča lopatica',
            recommendationAction: 'Priporočilo in ukrepanje',
            addToCurrentlyInstalled: 'Dodaj k trenutno nameščenim',
            add: 'Dodaj',
            remove: 'Odstrani',
            grams: 'gramov',
            recommended: 'Priporočeno',
            yourAction: 'Vaše dejanje',
            totalWeight: 'Skupna teža',
            goToNextStep: 'Naslednji korak',
            next: 'Naprej',
            goToPreviousStep: 'Prejšnji korak',
            generateReport: 'Ustvari poročilo PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Diagram uravnoteženja',
            plotLegendRecommended: 'Trenutna vibracija',
            plotLegendYourAction: 'Vaše dejanje',
        },
        tailRotor: {
            backToHome: 'Nazaj na domačo stran',
            title: 'Zadnji rotor',
            step: 'Korak',
            rotorIsBalanced: 'Rotor je uravnotežen!',
            vibrationBelowThreshold: 'Amplituda vibracij ({amplitude} IPS) je pod pragom 0,2 IPS.',
            vibrationMeasurement: 'Merjenje vibracij',
            amplitudeLabel: 'Amplituda <i>IPS</i>',
            phaseLabelHHMM: 'Faza <i>uu:mm</i>',
            phaseLabelDegrees: '<i>stopinje</i>',
            phaseLabelDegreesShort: 'Stopinje',
            installedWeights: 'Nameščene uteži',
            detailedWeightDistribution: 'Podrobna porazdelitev teže',
            detailedSetup: 'Podrobna Nastavitev',
            screwLabel: 'Vijak',
            smallWashers: 'Majhne Podložke',
            largeWashers: 'Velike Podložke',
            current: 'Trenutno',
            final: 'Končno',
            add: 'Dodaj',
            remove: 'Odstrani',
            washers: 'podložke',
            enterWashers: 'Vnesite podložke, ki so trenutno на rotorju.',
            fromPreviousStep: '(Iz prejšnjega koraka)',
            small: 'Majhna',
            large: 'Velika',
            recommendation: 'Priporočilo',
            recommendationFinalSetup: 'Priporočilo in končna nastavitev',
            recommendedFinalWashers: 'Priporočene končne podložke (skupaj)',
            yourFinalWasherSetup: 'Vaša končna nastavitev podložk (skupaj)',
            editFinalSetup: 'Uredite tukaj, da se ujema s podložkami, ki ste jih dejansko namestili, če se razlikujejo od priporočila.',
            goToNextStep: 'Naslednji korak',
            next: 'Naprej',
            goToPreviousStep: 'Prejšnji korak',
            generateReport: 'Ustvari poročilo PDF',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Diagram uravnoteženja',
        }
    },
    mn: {
        common: {
            resetLearning: "↺ Суралцахыг дахин тохируулах",
            resetConfirm: "Та pitch links эсвэл trim tabs-ийг тохируулсан уу?\n\nЭнэ нь өмнөх алхмуудын түүхийг устгах тул алгоритм шинэ аэродинамик тохиргоог сурах боломжтой болно.\n\nТа итгэлтэй байна уу?",
        },
        help: {
            pitchLinkReset: "Blade Track тохируулгын дараа: Хэрэв та pitch links эсвэл trim tabs-ийг тохируулбал роторын үйлдэл өөрчлөгдөнө. Хуучин түүхийг устгахын тулд 'Суралцахыг дахин тохируулах' товчийг дарах ёстой. Дараагийн ажиллуулалт нь шинэ тохируулгын алхам болно."
        },
        home: {
            title: 'G-Tune',
            subtitle: 'Cabri G2 Роторын тэнцвэржүүлэх туслах',
            mainRotor: 'Үндсэн ротор',
            tailRotor: 'Арын ротор',
            language: 'Хэл',
        },
        mainRotor: {
            backToHome: 'Нүүр хуудас руу буцах',
            title: 'Үндсэн ротор',
            step: 'Алхам',
            rotorIsBalanced: 'Ротор тэнцвэржсэн!',
            vibrationBelowThreshold: 'Чичиргээний далайц ({amplitude} IPS) 0.2 IPS-ийн босгоос доогуур байна.',
            overweightWarningTitle: 'Жижиг хөндий дүүрсэн!',
            overweightWarningText: 'Зөвлөмж 16г-аас хэтэрч байна. support@guimbal.com хаягаар холбогдоно уу.',
            vibrationMeasurement: 'Чичиргээний хэмжилт',
            amplitudeLabel: 'Далайц <i>IPS</i>',
            phaseLabelHHMM: 'Фааз <i>цаг:мин</i>',
            phaseLabelDegrees: '<i>градус</i>',
            phaseLabelDegreesShort: 'Градус',
            weightDistribution: 'Жингийн хуваарилалт',
            detailedWeightDistribution: 'Дэлгэрэнгүй тохиргоо',
            currentlyInstalled: 'Одоогийн',
            current: 'Одоогийн',
            final: 'Эцсийн',
            fromPreviousStep: 'Өмнөх алхмаас.',
            yellowBlade: 'Шар сэнс',
            greenBlade: 'Ногоон сэнс',
            redBlade: 'Улаан сэнс',
            recommendationAction: 'Зөвлөмж ба Үйлдэл',
            addToCurrentlyInstalled: 'Одоогийн суурилуулсан дээр нэмэх',
            add: 'Нэмэх',
            remove: 'Хасах',
            grams: 'грамм',
            recommended: 'Зөвлөсөн',
            yourAction: 'Таны үйлдэл',
            totalWeight: 'Нийт жин',
            goToNextStep: 'Дараагийн алхам',
            next: 'Дараах',
            goToPreviousStep: 'Өмнөх алхам',
            generateReport: 'PDF тайлан үүсгэх',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Тэнцвэржүүлэх график',
            plotLegendRecommended: 'Одоогийн чичиргээ',
            plotLegendYourAction: 'Таны үйлдэл',
        },
        tailRotor: {
            backToHome: 'Нүүр хуудас руу буцах',
            title: 'Арын ротор',
            step: 'Алхам',
            rotorIsBalanced: 'Ротор тэнцвэржсэн!',
            vibrationBelowThreshold: 'Чичиргээний далайц ({amplitude} IPS) 0.2 IPS-ийн босгоос доогуур байна.',
            vibrationMeasurement: 'Чичиргээний хэмжилт',
            amplitudeLabel: 'Далайц <i>IPS</i>',
            phaseLabelHHMM: 'Фааз <i>цаг:мин</i>',
            phaseLabelDegrees: '<i>градус</i>',
            phaseLabelDegreesShort: 'Градус',
            installedWeights: 'Суурилуулсан жин',
            detailedWeightDistribution: 'Жингийн дэлгэрэнгүй хуваарилалт',
            detailedSetup: 'Дэлгэрэнгүй тохиргоо',
            screwLabel: 'Шураг',
            smallWashers: 'Жижиг Угаагч',
            largeWashers: 'Том Угаагч',
            current: 'Одоогийн',
            final: 'Эцсийн',
            add: 'Нэмэх',
            remove: 'Хасах',
            washers: 'угаагч',
            enterWashers: 'Ротор дээр одоогоор байгаа угаагчийг оруулна уу.',
            fromPreviousStep: '(Өмнөх алхмаас)',
            small: 'Жижиг',
            large: 'Том',
            recommendation: 'Зөвлөмж',
            recommendationFinalSetup: 'Зөвлөмж ба Эцсийн тохиргоо',
            recommendedFinalWashers: 'Зөвлөсөн эцсийн угаагч (нийт)',
            yourFinalWasherSetup: 'Таны эцсийн угаагчийн тохиргоо (нийт)',
            editFinalSetup: 'Хэрэв зөвлөмжөөс өөр бол таны суулгасан угаагчтай тааруулахын тулд энд засварлана уу.',
            goToNextStep: 'Дараагийн алхам',
            next: 'Дараах',
            goToPreviousStep: 'Өмнөх алхам',
            generateReport: 'PDF тайлан үүсгэх',
            interpolatedValues: 'K={kValue}, Phi={phiValue}°',
            plotTitle: 'Тэнцвэржүүлэх график',
        }
    }
};

export const langNames = {
    en: 'English',
    fr: 'Français',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    zh: '中文',
    hy: 'Հայերեն',
    ms: 'Bahasa Melayu',
    pl: 'Polski',
    cs: 'Čeština',
    ro: 'Română',
    pt: 'Português',
    nl: 'Nederlands',
    sv: 'Svenska',
    da: 'Dansk',
    fi: 'Suomi',
    uk: 'Українська',
    he: 'עברית',
    vi: 'Tiếng Việt',
    et: 'Eesti',
    lv: 'Latviešu',
    lt: 'Lietuvių',
    sl: 'Slovenščina',
    mn: 'Монгол'
};